
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("ce5rQ", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $8e6b04b3847adb3b$var$isNil(value) {
    return value == null;
}
module.exports = $8e6b04b3847adb3b$var$isNil;

});

parcelRegister("1cdfS", function(module, exports) {

var $cmhx4 = parcelRequire("cmhx4");

var $6g2OA = parcelRequire("6g2OA");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $0df131a2258890a8$var$pick = $6g2OA(function(object, paths) {
    return object == null ? {} : $cmhx4(object, paths);
});
module.exports = $0df131a2258890a8$var$pick;

});
parcelRegister("cmhx4", function(module, exports) {

var $heyMR = parcelRequire("heyMR");

var $foXe7 = parcelRequire("foXe7");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $8ff523b3f67d9af2$var$basePick(object, paths) {
    return $heyMR(object, paths, function(value, path) {
        return $foXe7(object, path);
    });
}
module.exports = $8ff523b3f67d9af2$var$basePick;

});

parcelRegister("6g2OA", function(module, exports) {

var $h7zaC = parcelRequire("h7zaC");

var $93zTF = parcelRequire("93zTF");

var $AJjcO = parcelRequire("AJjcO");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $48e66bb0dfc6c4eb$var$flatRest(func) {
    return $AJjcO($93zTF(func, undefined, $h7zaC), func + '');
}
module.exports = $48e66bb0dfc6c4eb$var$flatRest;

});


parcelRegister("QvfgV", function(module, exports) {

var $99sAp = parcelRequire("99sAp");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $09dd181d129399f1$var$set(object, path, value) {
    return object == null ? object : $99sAp(object, path, value);
}
module.exports = $09dd181d129399f1$var$set;

});

parcelRegister("70q2o", function(module, exports) {
$parcel$export(module.exports, "default", () => $519cbb08510d35f2$export$2e2bcd8739ae039);

var $eCErp = parcelRequire("eCErp");

var $bgDfu = parcelRequire("bgDfu");

var $bW0nV = parcelRequire("bW0nV");

var $gOSTW = parcelRequire("gOSTW");

var $2haYp = parcelRequire("2haYp");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var $519cbb08510d35f2$var$locale = {
    code: 'ar-DZ',
    formatDistance: (0, $eCErp.default),
    formatLong: (0, $bgDfu.default),
    formatRelative: (0, $bW0nV.default),
    localize: (0, $gOSTW.default),
    match: (0, $2haYp.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $519cbb08510d35f2$export$2e2bcd8739ae039 = $519cbb08510d35f2$var$locale;

});
parcelRegister("eCErp", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa53fc110b2cd243$export$2e2bcd8739ae039);
var $aa53fc110b2cd243$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $aa53fc110b2cd243$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $aa53fc110b2cd243$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $aa53fc110b2cd243$export$2e2bcd8739ae039 = $aa53fc110b2cd243$var$formatDistance;

});

parcelRegister("bgDfu", function(module, exports) {
$parcel$export(module.exports, "default", () => $833fa25a44c1c283$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $833fa25a44c1c283$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $833fa25a44c1c283$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $833fa25a44c1c283$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $833fa25a44c1c283$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $833fa25a44c1c283$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $833fa25a44c1c283$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $833fa25a44c1c283$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $833fa25a44c1c283$export$2e2bcd8739ae039 = $833fa25a44c1c283$var$formatLong;

});

parcelRegister("bW0nV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b0568ef71310f01$export$2e2bcd8739ae039);
var $8b0568ef71310f01$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $8b0568ef71310f01$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $8b0568ef71310f01$var$formatRelativeLocale[token];
};
var $8b0568ef71310f01$export$2e2bcd8739ae039 = $8b0568ef71310f01$var$formatRelative;

});

parcelRegister("gOSTW", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3ebe715b91de56e$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $c3ebe715b91de56e$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $c3ebe715b91de56e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $c3ebe715b91de56e$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $c3ebe715b91de56e$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $c3ebe715b91de56e$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $c3ebe715b91de56e$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $c3ebe715b91de56e$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $c3ebe715b91de56e$var$localize = {
    ordinalNumber: $c3ebe715b91de56e$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $c3ebe715b91de56e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $c3ebe715b91de56e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $c3ebe715b91de56e$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $c3ebe715b91de56e$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $c3ebe715b91de56e$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c3ebe715b91de56e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c3ebe715b91de56e$export$2e2bcd8739ae039 = $c3ebe715b91de56e$var$localize;

});

parcelRegister("2haYp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a85ae66d404af25$export$2e2bcd8739ae039);

var $ifMvQ = parcelRequire("ifMvQ");

var $5CeaO = parcelRequire("5CeaO");
var $1a85ae66d404af25$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $1a85ae66d404af25$var$parseOrdinalNumberPattern = /\d+/i;
var $1a85ae66d404af25$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $1a85ae66d404af25$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $1a85ae66d404af25$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $1a85ae66d404af25$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1a85ae66d404af25$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var $1a85ae66d404af25$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var $1a85ae66d404af25$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $1a85ae66d404af25$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $1a85ae66d404af25$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $1a85ae66d404af25$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $1a85ae66d404af25$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $1a85ae66d404af25$var$matchOrdinalNumberPattern,
        parsePattern: $1a85ae66d404af25$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $1a85ae66d404af25$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a85ae66d404af25$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $1a85ae66d404af25$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a85ae66d404af25$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $1a85ae66d404af25$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a85ae66d404af25$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $1a85ae66d404af25$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a85ae66d404af25$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $1a85ae66d404af25$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $1a85ae66d404af25$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1a85ae66d404af25$export$2e2bcd8739ae039 = $1a85ae66d404af25$var$match;

});


parcelRegister("f7iBE", function(module, exports) {
$parcel$export(module.exports, "default", () => $b015f1430199fac9$export$2e2bcd8739ae039);

var $iaux3 = parcelRequire("iaux3");

var $7TdG1 = parcelRequire("7TdG1");

var $1BDho = parcelRequire("1BDho");

var $6ob3U = parcelRequire("6ob3U");

var $2EPLO = parcelRequire("2EPLO");
/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var $b015f1430199fac9$var$locale = {
    code: 'cs',
    formatDistance: (0, $iaux3.default),
    formatLong: (0, $7TdG1.default),
    formatRelative: (0, $1BDho.default),
    localize: (0, $6ob3U.default),
    match: (0, $2EPLO.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $b015f1430199fac9$export$2e2bcd8739ae039 = $b015f1430199fac9$var$locale;

});
parcelRegister("iaux3", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3a0d8307b91f730$export$2e2bcd8739ae039);
var $d3a0d8307b91f730$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E sekundou",
            future: "za m\xe9n\u011B ne\u017E sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "p\u0159ed sekundou",
            future: 'za sekundu'
        },
        few: {
            regular: '{{count}} sekundy',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekundy'
        },
        many: {
            regular: '{{count}} sekund',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekund'
        }
    },
    halfAMinute: {
        type: 'other',
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "p\u0159ed minutou",
            future: 'za minutu'
        },
        few: {
            regular: '{{count}} minuty',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minuty'
        },
        many: {
            regular: '{{count}} minut',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minut'
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: "p\u0159ed hodinou",
            future: 'za hodinu'
        },
        few: {
            regular: '{{count}} hodiny',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodiny'
        },
        many: {
            regular: '{{count}} hodin',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodin'
        }
    },
    xDays: {
        one: {
            regular: 'den',
            past: "p\u0159ed dnem",
            future: 'za den'
        },
        few: {
            regular: '{{count}} dny',
            past: "p\u0159ed {{count}} dny",
            future: 'za {{count}} dny'
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: "p\u0159ed rokem",
            future: 'za rok'
        },
        few: {
            regular: '{{count}} roky',
            past: "p\u0159ed {{count}} roky",
            future: 'za {{count}} roky'
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: 'skoro rok',
            past: "skoro p\u0159ed rokem",
            future: 'skoro za rok'
        },
        few: {
            regular: 'skoro {{count}} roky',
            past: "skoro p\u0159ed {{count}} roky",
            future: 'skoro za {{count}} roky'
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
var $d3a0d8307b91f730$var$formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = $d3a0d8307b91f730$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === 'other') pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace('{{count}}', String(count));
};
var $d3a0d8307b91f730$export$2e2bcd8739ae039 = $d3a0d8307b91f730$var$formatDistance;

});

parcelRegister("7TdG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5be84762bb4c6b01$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $5be84762bb4c6b01$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy',
    long: 'd. MMMM yyyy',
    medium: 'd. M. yyyy',
    short: 'dd.MM.yyyy'
};
var $5be84762bb4c6b01$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $5be84762bb4c6b01$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $5be84762bb4c6b01$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $5be84762bb4c6b01$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $5be84762bb4c6b01$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $5be84762bb4c6b01$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $5be84762bb4c6b01$export$2e2bcd8739ae039 = $5be84762bb4c6b01$var$formatLong;

});

parcelRegister("1BDho", function(module, exports) {
$parcel$export(module.exports, "default", () => $12b7b73e1cf8d010$export$2e2bcd8739ae039);
var $12b7b73e1cf8d010$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    'sobotu'
];
var $12b7b73e1cf8d010$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + $12b7b73e1cf8d010$var$accusativeWeekdays[day] + " o' p";
    },
    other: 'P'
};
var $12b7b73e1cf8d010$var$formatRelative = function formatRelative(token, date) {
    var format = $12b7b73e1cf8d010$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $12b7b73e1cf8d010$export$2e2bcd8739ae039 = $12b7b73e1cf8d010$var$formatRelative;

});

parcelRegister("6ob3U", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a6d90a9f2d93a8b$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $4a6d90a9f2d93a8b$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    abbreviated: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var $4a6d90a9f2d93a8b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var $4a6d90a9f2d93a8b$var$monthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'leden',
        "\xfanor",
        "b\u0159ezen",
        'duben',
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        'srpen',
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        'listopad',
        'prosinec'
    ]
};
var $4a6d90a9f2d93a8b$var$formattingMonthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'ledna',
        "\xfanora",
        "b\u0159ezna",
        'dubna',
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        'srpna',
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        'listopadu',
        'prosince'
    ]
};
var $4a6d90a9f2d93a8b$var$dayValues = {
    narrow: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    short: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    abbreviated: [
        'ned',
        'pon',
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        'sob'
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        'sobota'
    ]
};
var $4a6d90a9f2d93a8b$var$dayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $4a6d90a9f2d93a8b$var$formattingDayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $4a6d90a9f2d93a8b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $4a6d90a9f2d93a8b$var$localize = {
    ordinalNumber: $4a6d90a9f2d93a8b$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $4a6d90a9f2d93a8b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $4a6d90a9f2d93a8b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $4a6d90a9f2d93a8b$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $4a6d90a9f2d93a8b$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $4a6d90a9f2d93a8b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $4a6d90a9f2d93a8b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4a6d90a9f2d93a8b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4a6d90a9f2d93a8b$export$2e2bcd8739ae039 = $4a6d90a9f2d93a8b$var$localize;

});

parcelRegister("2EPLO", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ef779ab123b95f9$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $1ef779ab123b95f9$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $1ef779ab123b95f9$var$parseOrdinalNumberPattern = /\d+/i;
var $1ef779ab123b95f9$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var $1ef779ab123b95f9$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var $1ef779ab123b95f9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var $1ef779ab123b95f9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1ef779ab123b95f9$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var $1ef779ab123b95f9$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var $1ef779ab123b95f9$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var $1ef779ab123b95f9$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var $1ef779ab123b95f9$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var $1ef779ab123b95f9$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var $1ef779ab123b95f9$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $1ef779ab123b95f9$var$matchOrdinalNumberPattern,
        parsePattern: $1ef779ab123b95f9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $1ef779ab123b95f9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1ef779ab123b95f9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $1ef779ab123b95f9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1ef779ab123b95f9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $1ef779ab123b95f9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1ef779ab123b95f9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $1ef779ab123b95f9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1ef779ab123b95f9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $1ef779ab123b95f9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $1ef779ab123b95f9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1ef779ab123b95f9$export$2e2bcd8739ae039 = $1ef779ab123b95f9$var$match;

});


parcelRegister("lVZwL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff7ea5ee09074891$export$2e2bcd8739ae039);

var $1g6kn = parcelRequire("1g6kn");

var $fIufI = parcelRequire("fIufI");

var $hyxwb = parcelRequire("hyxwb");

var $eepRo = parcelRequire("eepRo");

var $8KHzn = parcelRequire("8KHzn");
/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var $ff7ea5ee09074891$var$locale = {
    code: 'da',
    formatDistance: (0, $1g6kn.default),
    formatLong: (0, $fIufI.default),
    formatRelative: (0, $hyxwb.default),
    localize: (0, $eepRo.default),
    match: (0, $8KHzn.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $ff7ea5ee09074891$export$2e2bcd8739ae039 = $ff7ea5ee09074891$var$locale;

});
parcelRegister("1g6kn", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eac319eb80ff972$export$2e2bcd8739ae039);
var $0eac319eb80ff972$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: 'mindre end {{count}} sekunder'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: 'mindre end {{count}} minutter'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'cirka 1 time',
        other: 'cirka {{count}} timer'
    },
    xHours: {
        one: '1 time',
        other: '{{count}} timer'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dage'
    },
    aboutXWeeks: {
        one: 'cirka 1 uge',
        other: 'cirka {{count}} uger'
    },
    xWeeks: {
        one: '1 uge',
        other: '{{count}} uger'
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var $0eac319eb80ff972$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0eac319eb80ff972$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $0eac319eb80ff972$export$2e2bcd8739ae039 = $0eac319eb80ff972$var$formatDistance;

});

parcelRegister("fIufI", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7126e976003163e$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $b7126e976003163e$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd/MM/y'
};
var $b7126e976003163e$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b7126e976003163e$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $b7126e976003163e$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $b7126e976003163e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $b7126e976003163e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $b7126e976003163e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b7126e976003163e$export$2e2bcd8739ae039 = $b7126e976003163e$var$formatLong;

});

parcelRegister("hyxwb", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc7f9ca2486ae962$export$2e2bcd8739ae039);
var $cc7f9ca2486ae962$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: 'P'
};
var $cc7f9ca2486ae962$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $cc7f9ca2486ae962$var$formatRelativeLocale[token];
};
var $cc7f9ca2486ae962$export$2e2bcd8739ae039 = $cc7f9ca2486ae962$var$formatRelative;

});

parcelRegister("eepRo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5c66ecbc5516e98$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $a5c66ecbc5516e98$var$eraValues = {
    narrow: [
        'fvt',
        'vt'
    ],
    abbreviated: [
        'f.v.t.',
        'v.t.'
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        'vesterlandsk tidsregning'
    ]
};
var $a5c66ecbc5516e98$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. kvt.',
        '2. kvt.',
        '3. kvt.',
        '4. kvt.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $a5c66ecbc5516e98$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marts',
        'april',
        'maj',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var $a5c66ecbc5516e98$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        'man.',
        'tir.',
        'ons.',
        'tor.',
        'fre.',
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $a5c66ecbc5516e98$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    }
};
var $a5c66ecbc5516e98$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    }
};
var $a5c66ecbc5516e98$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $a5c66ecbc5516e98$var$localize = {
    ordinalNumber: $a5c66ecbc5516e98$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $a5c66ecbc5516e98$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $a5c66ecbc5516e98$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $a5c66ecbc5516e98$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $a5c66ecbc5516e98$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $a5c66ecbc5516e98$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a5c66ecbc5516e98$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a5c66ecbc5516e98$export$2e2bcd8739ae039 = $a5c66ecbc5516e98$var$localize;

});

parcelRegister("8KHzn", function(module, exports) {
$parcel$export(module.exports, "default", () => $65f46aa1783fefbf$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $65f46aa1783fefbf$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $65f46aa1783fefbf$var$parseOrdinalNumberPattern = /\d+/i;
var $65f46aa1783fefbf$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var $65f46aa1783fefbf$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var $65f46aa1783fefbf$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var $65f46aa1783fefbf$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $65f46aa1783fefbf$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var $65f46aa1783fefbf$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $65f46aa1783fefbf$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $65f46aa1783fefbf$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $65f46aa1783fefbf$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var $65f46aa1783fefbf$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var $65f46aa1783fefbf$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $65f46aa1783fefbf$var$matchOrdinalNumberPattern,
        parsePattern: $65f46aa1783fefbf$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $65f46aa1783fefbf$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $65f46aa1783fefbf$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $65f46aa1783fefbf$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $65f46aa1783fefbf$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $65f46aa1783fefbf$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $65f46aa1783fefbf$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $65f46aa1783fefbf$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $65f46aa1783fefbf$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $65f46aa1783fefbf$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $65f46aa1783fefbf$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $65f46aa1783fefbf$export$2e2bcd8739ae039 = $65f46aa1783fefbf$var$match;

});


parcelRegister("3Fhok", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ab2b1068aa85d76$export$2e2bcd8739ae039);

var $fRRac = parcelRequire("fRRac");

var $94tWc = parcelRequire("94tWc");

var $gvSj0 = parcelRequire("gvSj0");

var $gfzZ6 = parcelRequire("gfzZ6");

var $6qdHE = parcelRequire("6qdHE");
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $2ab2b1068aa85d76$var$locale = {
    code: 'de',
    formatDistance: (0, $fRRac.default),
    formatLong: (0, $94tWc.default),
    formatRelative: (0, $gvSj0.default),
    localize: (0, $gfzZ6.default),
    match: (0, $6qdHE.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2ab2b1068aa85d76$export$2e2bcd8739ae039 = $2ab2b1068aa85d76$var$locale;

});
parcelRegister("fRRac", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8d50b6e4346feac$export$2e2bcd8739ae039);
var $b8d50b6e4346feac$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var $b8d50b6e4346feac$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $b8d50b6e4346feac$var$formatDistanceLocale[token].withPreposition : $b8d50b6e4346feac$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
var $b8d50b6e4346feac$export$2e2bcd8739ae039 = $b8d50b6e4346feac$var$formatDistance;

});

parcelRegister("94tWc", function(module, exports) {
$parcel$export(module.exports, "default", () => $69abb5ce6f21cff7$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $69abb5ce6f21cff7$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var $69abb5ce6f21cff7$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $69abb5ce6f21cff7$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $69abb5ce6f21cff7$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $69abb5ce6f21cff7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $69abb5ce6f21cff7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $69abb5ce6f21cff7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $69abb5ce6f21cff7$export$2e2bcd8739ae039 = $69abb5ce6f21cff7$var$formatLong;

});

parcelRegister("gvSj0", function(module, exports) {
$parcel$export(module.exports, "default", () => $c059aa850bd7ff9b$export$2e2bcd8739ae039);
var $c059aa850bd7ff9b$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $c059aa850bd7ff9b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c059aa850bd7ff9b$var$formatRelativeLocale[token];
};
var $c059aa850bd7ff9b$export$2e2bcd8739ae039 = $c059aa850bd7ff9b$var$formatRelative;

});

parcelRegister("gfzZ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd49f5d1a98596f0$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $bd49f5d1a98596f0$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $bd49f5d1a98596f0$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $bd49f5d1a98596f0$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $bd49f5d1a98596f0$var$formattingMonthValues = {
    narrow: $bd49f5d1a98596f0$var$monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $bd49f5d1a98596f0$var$monthValues.wide
};
var $bd49f5d1a98596f0$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $bd49f5d1a98596f0$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $bd49f5d1a98596f0$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $bd49f5d1a98596f0$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $bd49f5d1a98596f0$var$localize = {
    ordinalNumber: $bd49f5d1a98596f0$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $bd49f5d1a98596f0$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $bd49f5d1a98596f0$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $bd49f5d1a98596f0$var$monthValues,
        formattingValues: $bd49f5d1a98596f0$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $bd49f5d1a98596f0$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $bd49f5d1a98596f0$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $bd49f5d1a98596f0$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $bd49f5d1a98596f0$export$2e2bcd8739ae039 = $bd49f5d1a98596f0$var$localize;

});

parcelRegister("6qdHE", function(module, exports) {
$parcel$export(module.exports, "default", () => $4acfccedf0f796c6$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $4acfccedf0f796c6$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $4acfccedf0f796c6$var$parseOrdinalNumberPattern = /\d+/i;
var $4acfccedf0f796c6$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $4acfccedf0f796c6$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $4acfccedf0f796c6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $4acfccedf0f796c6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4acfccedf0f796c6$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $4acfccedf0f796c6$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $4acfccedf0f796c6$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $4acfccedf0f796c6$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $4acfccedf0f796c6$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $4acfccedf0f796c6$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $4acfccedf0f796c6$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $4acfccedf0f796c6$var$matchOrdinalNumberPattern,
        parsePattern: $4acfccedf0f796c6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $4acfccedf0f796c6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4acfccedf0f796c6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $4acfccedf0f796c6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4acfccedf0f796c6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $4acfccedf0f796c6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4acfccedf0f796c6$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $4acfccedf0f796c6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4acfccedf0f796c6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $4acfccedf0f796c6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4acfccedf0f796c6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4acfccedf0f796c6$export$2e2bcd8739ae039 = $4acfccedf0f796c6$var$match;

});


parcelRegister("7JPfT", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a247e9d717a2d63$export$2e2bcd8739ae039);

var $4Y2LP = parcelRequire("4Y2LP");

var $hZdTl = parcelRequire("hZdTl");

var $grP5d = parcelRequire("grP5d");

var $8hOPC = parcelRequire("8hOPC");

var $ls73k = parcelRequire("ls73k");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var $5a247e9d717a2d63$var$locale = {
    code: 'en-AU',
    formatDistance: (0, $4Y2LP.default),
    formatLong: (0, $hZdTl.default),
    formatRelative: (0, $grP5d.default),
    localize: (0, $8hOPC.default),
    match: (0, $ls73k.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5a247e9d717a2d63$export$2e2bcd8739ae039 = $5a247e9d717a2d63$var$locale;

});
parcelRegister("hZdTl", function(module, exports) {
$parcel$export(module.exports, "default", () => $d182e8c9184f57dc$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $d182e8c9184f57dc$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $d182e8c9184f57dc$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $d182e8c9184f57dc$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d182e8c9184f57dc$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $d182e8c9184f57dc$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $d182e8c9184f57dc$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $d182e8c9184f57dc$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d182e8c9184f57dc$export$2e2bcd8739ae039 = $d182e8c9184f57dc$var$formatLong;

});


parcelRegister("5lS47", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e58da308cc8c161$export$2e2bcd8739ae039);

var $4Y2LP = parcelRequire("4Y2LP");

var $grP5d = parcelRequire("grP5d");

var $8hOPC = parcelRequire("8hOPC");

var $ls73k = parcelRequire("ls73k");

var $56pDm = parcelRequire("56pDm");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $3e58da308cc8c161$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $4Y2LP.default),
    formatLong: (0, $56pDm.default),
    formatRelative: (0, $grP5d.default),
    localize: (0, $8hOPC.default),
    match: (0, $ls73k.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $3e58da308cc8c161$export$2e2bcd8739ae039 = $3e58da308cc8c161$var$locale;

});
parcelRegister("56pDm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b7165a489a46376$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $3b7165a489a46376$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $3b7165a489a46376$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $3b7165a489a46376$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $3b7165a489a46376$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $3b7165a489a46376$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $3b7165a489a46376$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $3b7165a489a46376$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3b7165a489a46376$export$2e2bcd8739ae039 = $3b7165a489a46376$var$formatLong;

});


parcelRegister("71w7M", function(module, exports) {
$parcel$export(module.exports, "default", () => $51d18bac3be5bb44$export$2e2bcd8739ae039);

var $faOGg = parcelRequire("faOGg");

var $kVq5J = parcelRequire("kVq5J");

var $3jSiQ = parcelRequire("3jSiQ");

var $aTB1A = parcelRequire("aTB1A");

var $4yXz6 = parcelRequire("4yXz6");
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $51d18bac3be5bb44$var$locale = {
    code: 'es',
    formatDistance: (0, $faOGg.default),
    formatLong: (0, $kVq5J.default),
    formatRelative: (0, $3jSiQ.default),
    localize: (0, $aTB1A.default),
    match: (0, $4yXz6.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $51d18bac3be5bb44$export$2e2bcd8739ae039 = $51d18bac3be5bb44$var$locale;

});
parcelRegister("faOGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0bf1a5035dc5ca9$export$2e2bcd8739ae039);
var $b0bf1a5035dc5ca9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var $b0bf1a5035dc5ca9$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b0bf1a5035dc5ca9$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
};
var $b0bf1a5035dc5ca9$export$2e2bcd8739ae039 = $b0bf1a5035dc5ca9$var$formatDistance;

});

parcelRegister("kVq5J", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3bd5eb70a76f8d2$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $f3bd5eb70a76f8d2$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $f3bd5eb70a76f8d2$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $f3bd5eb70a76f8d2$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f3bd5eb70a76f8d2$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $f3bd5eb70a76f8d2$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $f3bd5eb70a76f8d2$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $f3bd5eb70a76f8d2$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f3bd5eb70a76f8d2$export$2e2bcd8739ae039 = $f3bd5eb70a76f8d2$var$formatLong;

});

parcelRegister("3jSiQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $26ad44e00870a264$export$2e2bcd8739ae039);
var $26ad44e00870a264$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $26ad44e00870a264$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
var $26ad44e00870a264$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $26ad44e00870a264$var$formatRelativeLocalePlural[token];
    else return $26ad44e00870a264$var$formatRelativeLocale[token];
};
var $26ad44e00870a264$export$2e2bcd8739ae039 = $26ad44e00870a264$var$formatRelative;

});

parcelRegister("aTB1A", function(module, exports) {
$parcel$export(module.exports, "default", () => $7eebc2c64b722b49$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $7eebc2c64b722b49$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var $7eebc2c64b722b49$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $7eebc2c64b722b49$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var $7eebc2c64b722b49$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        "s\xe1"
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var $7eebc2c64b722b49$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var $7eebc2c64b722b49$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
var $7eebc2c64b722b49$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $7eebc2c64b722b49$var$localize = {
    ordinalNumber: $7eebc2c64b722b49$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $7eebc2c64b722b49$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $7eebc2c64b722b49$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $7eebc2c64b722b49$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $7eebc2c64b722b49$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $7eebc2c64b722b49$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $7eebc2c64b722b49$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $7eebc2c64b722b49$export$2e2bcd8739ae039 = $7eebc2c64b722b49$var$localize;

});

parcelRegister("4yXz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $35288accc15e8873$export$2e2bcd8739ae039);

var $ifMvQ = parcelRequire("ifMvQ");

var $5CeaO = parcelRequire("5CeaO");
var $35288accc15e8873$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $35288accc15e8873$var$parseOrdinalNumberPattern = /\d+/i;
var $35288accc15e8873$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $35288accc15e8873$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $35288accc15e8873$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $35288accc15e8873$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $35288accc15e8873$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $35288accc15e8873$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $35288accc15e8873$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $35288accc15e8873$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $35288accc15e8873$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $35288accc15e8873$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $35288accc15e8873$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $35288accc15e8873$var$matchOrdinalNumberPattern,
        parsePattern: $35288accc15e8873$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $35288accc15e8873$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $35288accc15e8873$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $35288accc15e8873$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $35288accc15e8873$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $35288accc15e8873$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $35288accc15e8873$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $35288accc15e8873$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $35288accc15e8873$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $35288accc15e8873$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $35288accc15e8873$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $35288accc15e8873$export$2e2bcd8739ae039 = $35288accc15e8873$var$match;

});


parcelRegister("l4Xsz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f58818294f0ac2a5$export$2e2bcd8739ae039);

var $jrmXW = parcelRequire("jrmXW");

var $lyJP1 = parcelRequire("lyJP1");

var $lQXqo = parcelRequire("lQXqo");

var $9FxvD = parcelRequire("9FxvD");

var $aPrkv = parcelRequire("aPrkv");
/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var $f58818294f0ac2a5$var$locale = {
    code: 'et',
    formatDistance: (0, $jrmXW.default),
    formatLong: (0, $lyJP1.default),
    formatRelative: (0, $lQXqo.default),
    localize: (0, $9FxvD.default),
    match: (0, $aPrkv.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $f58818294f0ac2a5$export$2e2bcd8739ae039 = $f58818294f0ac2a5$var$locale;

});
parcelRegister("jrmXW", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2725a71326e6cfc$export$2e2bcd8739ae039);
var $e2725a71326e6cfc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: '{{count}} sekundit'
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: '{{count}} sekundi'
        }
    },
    halfAMinute: {
        standalone: 'pool minutit',
        withPreposition: 'poole minuti'
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: '{{count}} minutit'
        },
        withPreposition: {
            one: "\xfche minuti",
            other: '{{count}} minuti'
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: 'umbes {{count}} tundi'
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: 'umbes {{count}} tunni'
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: '{{count}} tundi'
        },
        withPreposition: {
            one: "\xfche tunni",
            other: '{{count}} tunni'
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: 'umbes {{count}} kuud'
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: 'umbes {{count}} kuu'
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: '{{count}} kuud'
        },
        withPreposition: {
            one: "\xfche kuu",
            other: '{{count}} kuu'
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: 'umbes {{count}} aastat'
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: 'umbes {{count}} aasta'
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: '{{count}} aastat'
        },
        withPreposition: {
            one: "\xfche aasta",
            other: '{{count}} aasta'
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: 'rohkem kui {{count}} aastat'
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: 'rohkem kui {{count}} aasta'
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: 'peaaegu {{count}} aastat'
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: 'peaaegu {{count}} aasta'
        }
    }
};
var $e2725a71326e6cfc$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? $e2725a71326e6cfc$var$formatDistanceLocale[token].withPreposition : $e2725a71326e6cfc$var$formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + ' eest';
    }
    return result;
};
var $e2725a71326e6cfc$export$2e2bcd8739ae039 = $e2725a71326e6cfc$var$formatDistance;

});

parcelRegister("lyJP1", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb205135d984782f$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $fb205135d984782f$var$dateFormats = {
    full: 'EEEE, d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $fb205135d984782f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $fb205135d984782f$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: '{{date}}. {{time}}',
    short: '{{date}}. {{time}}'
};
var $fb205135d984782f$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $fb205135d984782f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $fb205135d984782f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $fb205135d984782f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $fb205135d984782f$export$2e2bcd8739ae039 = $fb205135d984782f$var$formatLong;

});

parcelRegister("lQXqo", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe8c8cd16f26b706$export$2e2bcd8739ae039);
var $fe8c8cd16f26b706$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: 'P'
};
var $fe8c8cd16f26b706$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $fe8c8cd16f26b706$var$formatRelativeLocale[token];
};
var $fe8c8cd16f26b706$export$2e2bcd8739ae039 = $fe8c8cd16f26b706$var$formatRelative;

});

parcelRegister("9FxvD", function(module, exports) {
$parcel$export(module.exports, "default", () => $70a1efa47a6dc180$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $70a1efa47a6dc180$var$eraValues = {
    narrow: [
        'e.m.a',
        'm.a.j'
    ],
    abbreviated: [
        'e.m.a',
        'm.a.j'
    ],
    wide: [
        'enne meie ajaarvamist',
        "meie ajaarvamise j\xe4rgi"
    ]
};
var $70a1efa47a6dc180$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $70a1efa47a6dc180$var$monthValues = {
    narrow: [
        'J',
        'V',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jaan',
        'veebr',
        "m\xe4rts",
        'apr',
        'mai',
        'juuni',
        'juuli',
        'aug',
        'sept',
        'okt',
        'nov',
        'dets'
    ],
    wide: [
        'jaanuar',
        'veebruar',
        "m\xe4rts",
        'aprill',
        'mai',
        'juuni',
        'juuli',
        'august',
        'september',
        'oktoober',
        'november',
        'detsember'
    ]
};
var $70a1efa47a6dc180$var$dayValues = {
    narrow: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    short: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    abbreviated: [
        "p\xfchap.",
        'esmasp.',
        'teisip.',
        'kolmap.',
        'neljap.',
        'reede.',
        'laup.'
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        'reede',
        "laup\xe4ev"
    ]
};
var $70a1efa47a6dc180$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var $70a1efa47a6dc180$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var $70a1efa47a6dc180$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $70a1efa47a6dc180$var$localize = {
    ordinalNumber: $70a1efa47a6dc180$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $70a1efa47a6dc180$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $70a1efa47a6dc180$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $70a1efa47a6dc180$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $70a1efa47a6dc180$var$monthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $70a1efa47a6dc180$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $70a1efa47a6dc180$var$dayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $70a1efa47a6dc180$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $70a1efa47a6dc180$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $70a1efa47a6dc180$export$2e2bcd8739ae039 = $70a1efa47a6dc180$var$localize;

});

parcelRegister("aPrkv", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e23dde9d7765be0$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $7e23dde9d7765be0$var$matchOrdinalNumberPattern = /^\d+\./i;
var $7e23dde9d7765be0$var$parseOrdinalNumberPattern = /\d+/i;
var $7e23dde9d7765be0$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var $7e23dde9d7765be0$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var $7e23dde9d7765be0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $7e23dde9d7765be0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7e23dde9d7765be0$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var $7e23dde9d7765be0$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7e23dde9d7765be0$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var $7e23dde9d7765be0$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var $7e23dde9d7765be0$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var $7e23dde9d7765be0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var $7e23dde9d7765be0$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $7e23dde9d7765be0$var$matchOrdinalNumberPattern,
        parsePattern: $7e23dde9d7765be0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $7e23dde9d7765be0$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7e23dde9d7765be0$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $7e23dde9d7765be0$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7e23dde9d7765be0$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $7e23dde9d7765be0$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7e23dde9d7765be0$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $7e23dde9d7765be0$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7e23dde9d7765be0$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $7e23dde9d7765be0$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7e23dde9d7765be0$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7e23dde9d7765be0$export$2e2bcd8739ae039 = $7e23dde9d7765be0$var$match;

});


parcelRegister("cSA4p", function(module, exports) {
$parcel$export(module.exports, "default", () => $960681f08a180188$export$2e2bcd8739ae039);

var $6spi1 = parcelRequire("6spi1");

var $AzAfj = parcelRequire("AzAfj");

var $k34ob = parcelRequire("k34ob");

var $j2SKd = parcelRequire("j2SKd");

var $1XcYm = parcelRequire("1XcYm");
/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var $960681f08a180188$var$locale = {
    code: 'fi',
    formatDistance: (0, $6spi1.default),
    formatLong: (0, $AzAfj.default),
    formatRelative: (0, $k34ob.default),
    localize: (0, $j2SKd.default),
    match: (0, $1XcYm.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $960681f08a180188$export$2e2bcd8739ae039 = $960681f08a180188$var$locale;

});
parcelRegister("6spi1", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b38f995be2d360d$export$2e2bcd8739ae039);
function $4b38f995be2d360d$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
}
function $4b38f995be2d360d$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
}
function $4b38f995be2d360d$var$futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
}
function $4b38f995be2d360d$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $4b38f995be2d360d$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
}
function $4b38f995be2d360d$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}
function $4b38f995be2d360d$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
}
var $4b38f995be2d360d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'alle sekunti',
        other: 'alle {{count}} sekuntia',
        futureTense: $4b38f995be2d360d$var$futureSeconds
    },
    xSeconds: {
        one: 'sekunti',
        other: '{{count}} sekuntia',
        futureTense: $4b38f995be2d360d$var$futureSeconds
    },
    halfAMinute: {
        one: 'puoli minuuttia',
        other: 'puoli minuuttia',
        futureTense: function futureTense(_text) {
            return 'puolen minuutin';
        }
    },
    lessThanXMinutes: {
        one: 'alle minuutti',
        other: 'alle {{count}} minuuttia',
        futureTense: $4b38f995be2d360d$var$futureMinutes
    },
    xMinutes: {
        one: 'minuutti',
        other: '{{count}} minuuttia',
        futureTense: $4b38f995be2d360d$var$futureMinutes
    },
    aboutXHours: {
        one: 'noin tunti',
        other: 'noin {{count}} tuntia',
        futureTense: $4b38f995be2d360d$var$futureHours
    },
    xHours: {
        one: 'tunti',
        other: '{{count}} tuntia',
        futureTense: $4b38f995be2d360d$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $4b38f995be2d360d$var$futureDays
    },
    aboutXWeeks: {
        one: 'noin viikko',
        other: 'noin {{count}} viikkoa',
        futureTense: $4b38f995be2d360d$var$futureWeeks
    },
    xWeeks: {
        one: 'viikko',
        other: '{{count}} viikkoa',
        futureTense: $4b38f995be2d360d$var$futureWeeks
    },
    aboutXMonths: {
        one: 'noin kuukausi',
        other: 'noin {{count}} kuukautta',
        futureTense: $4b38f995be2d360d$var$futureMonths
    },
    xMonths: {
        one: 'kuukausi',
        other: '{{count}} kuukautta',
        futureTense: $4b38f995be2d360d$var$futureMonths
    },
    aboutXYears: {
        one: 'noin vuosi',
        other: 'noin {{count}} vuotta',
        futureTense: $4b38f995be2d360d$var$futureYears
    },
    xYears: {
        one: 'vuosi',
        other: '{{count}} vuotta',
        futureTense: $4b38f995be2d360d$var$futureYears
    },
    overXYears: {
        one: 'yli vuosi',
        other: 'yli {{count}} vuotta',
        futureTense: $4b38f995be2d360d$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $4b38f995be2d360d$var$futureYears
    }
};
var $4b38f995be2d360d$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $4b38f995be2d360d$var$formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + ' kuluttua';
        else return result + ' sitten';
    }
    return result;
};
var $4b38f995be2d360d$export$2e2bcd8739ae039 = $4b38f995be2d360d$var$formatDistance;

});

parcelRegister("AzAfj", function(module, exports) {
$parcel$export(module.exports, "default", () => $06def7126317bcac$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $06def7126317bcac$var$dateFormats = {
    full: 'eeee d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'd.M.y'
};
var $06def7126317bcac$var$timeFormats = {
    full: 'HH.mm.ss zzzz',
    long: 'HH.mm.ss z',
    medium: 'HH.mm.ss',
    short: 'HH.mm'
};
var $06def7126317bcac$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $06def7126317bcac$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $06def7126317bcac$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $06def7126317bcac$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $06def7126317bcac$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $06def7126317bcac$export$2e2bcd8739ae039 = $06def7126317bcac$var$formatLong;

});

parcelRegister("k34ob", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9877e0898ee9df9$export$2e2bcd8739ae039);
var $e9877e0898ee9df9$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: 'P'
};
var $e9877e0898ee9df9$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e9877e0898ee9df9$var$formatRelativeLocale[token];
};
var $e9877e0898ee9df9$export$2e2bcd8739ae039 = $e9877e0898ee9df9$var$formatRelative;

});

parcelRegister("j2SKd", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddd8ab52b2dca34e$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $ddd8ab52b2dca34e$var$eraValues = {
    narrow: [
        'eaa.',
        'jaa.'
    ],
    abbreviated: [
        'eaa.',
        'jaa.'
    ],
    wide: [
        'ennen ajanlaskun alkua',
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var $ddd8ab52b2dca34e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartaali',
        '2. kvartaali',
        '3. kvartaali',
        '4. kvartaali'
    ]
};
var $ddd8ab52b2dca34e$var$monthValues = {
    narrow: [
        'T',
        'H',
        'M',
        'H',
        'T',
        'K',
        'H',
        'E',
        'S',
        'L',
        'M',
        'J'
    ],
    abbreviated: [
        'tammi',
        'helmi',
        'maalis',
        'huhti',
        'touko',
        "kes\xe4",
        "hein\xe4",
        'elo',
        'syys',
        'loka',
        'marras',
        'joulu'
    ],
    wide: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        "kes\xe4kuu",
        "hein\xe4kuu",
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu'
    ]
};
var $ddd8ab52b2dca34e$var$formattingMonthValues = {
    narrow: $ddd8ab52b2dca34e$var$monthValues.narrow,
    abbreviated: $ddd8ab52b2dca34e$var$monthValues.abbreviated,
    wide: [
        'tammikuuta',
        'helmikuuta',
        'maaliskuuta',
        'huhtikuuta',
        'toukokuuta',
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        'elokuuta',
        'syyskuuta',
        'lokakuuta',
        'marraskuuta',
        'joulukuuta'
    ]
};
var $ddd8ab52b2dca34e$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'K',
        'T',
        'P',
        'L'
    ],
    short: [
        'su',
        'ma',
        'ti',
        'ke',
        'to',
        'pe',
        'la'
    ],
    abbreviated: [
        'sunn.',
        'maan.',
        'tiis.',
        'kesk.',
        'torst.',
        'perj.',
        'la'
    ],
    wide: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai'
    ]
};
var $ddd8ab52b2dca34e$var$formattingDayValues = {
    narrow: $ddd8ab52b2dca34e$var$dayValues.narrow,
    short: $ddd8ab52b2dca34e$var$dayValues.short,
    abbreviated: $ddd8ab52b2dca34e$var$dayValues.abbreviated,
    wide: [
        'sunnuntaina',
        'maanantaina',
        'tiistaina',
        'keskiviikkona',
        'torstaina',
        'perjantaina',
        'lauantaina'
    ]
};
var $ddd8ab52b2dca34e$var$dayPeriodValues = {
    narrow: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    }
};
var $ddd8ab52b2dca34e$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $ddd8ab52b2dca34e$var$localize = {
    ordinalNumber: $ddd8ab52b2dca34e$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $ddd8ab52b2dca34e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $ddd8ab52b2dca34e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $ddd8ab52b2dca34e$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $ddd8ab52b2dca34e$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $ddd8ab52b2dca34e$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $ddd8ab52b2dca34e$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $ddd8ab52b2dca34e$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $ddd8ab52b2dca34e$export$2e2bcd8739ae039 = $ddd8ab52b2dca34e$var$localize;

});

parcelRegister("1XcYm", function(module, exports) {
$parcel$export(module.exports, "default", () => $16c55d38373d1272$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $16c55d38373d1272$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var $16c55d38373d1272$var$parseOrdinalNumberPattern = /\d+/i;
var $16c55d38373d1272$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var $16c55d38373d1272$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var $16c55d38373d1272$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var $16c55d38373d1272$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $16c55d38373d1272$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var $16c55d38373d1272$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var $16c55d38373d1272$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var $16c55d38373d1272$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var $16c55d38373d1272$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var $16c55d38373d1272$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var $16c55d38373d1272$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $16c55d38373d1272$var$matchOrdinalNumberPattern,
        parsePattern: $16c55d38373d1272$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $16c55d38373d1272$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $16c55d38373d1272$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $16c55d38373d1272$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $16c55d38373d1272$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $16c55d38373d1272$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $16c55d38373d1272$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $16c55d38373d1272$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $16c55d38373d1272$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $16c55d38373d1272$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $16c55d38373d1272$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $16c55d38373d1272$export$2e2bcd8739ae039 = $16c55d38373d1272$var$match;

});


parcelRegister("rZxQC", function(module, exports) {
$parcel$export(module.exports, "default", () => $05424345bb250d2c$export$2e2bcd8739ae039);

var $iktf2 = parcelRequire("iktf2");

var $jqAgc = parcelRequire("jqAgc");

var $6UJVQ = parcelRequire("6UJVQ");

var $kw7fy = parcelRequire("kw7fy");

var $imIHH = parcelRequire("imIHH");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $05424345bb250d2c$var$locale = {
    code: 'fr',
    formatDistance: (0, $iktf2.default),
    formatLong: (0, $jqAgc.default),
    formatRelative: (0, $6UJVQ.default),
    localize: (0, $kw7fy.default),
    match: (0, $imIHH.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $05424345bb250d2c$export$2e2bcd8739ae039 = $05424345bb250d2c$var$locale;

});
parcelRegister("iktf2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d580c6fd316093de$export$2e2bcd8739ae039);
var $d580c6fd316093de$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var $d580c6fd316093de$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $d580c6fd316093de$var$formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
var $d580c6fd316093de$export$2e2bcd8739ae039 = $d580c6fd316093de$var$formatDistance;

});

parcelRegister("jqAgc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e24c928d902e39b7$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $e24c928d902e39b7$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $e24c928d902e39b7$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e24c928d902e39b7$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e24c928d902e39b7$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $e24c928d902e39b7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $e24c928d902e39b7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $e24c928d902e39b7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e24c928d902e39b7$export$2e2bcd8739ae039 = $e24c928d902e39b7$var$formatLong;

});

parcelRegister("6UJVQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $508b9a27f41b760f$export$2e2bcd8739ae039);
var $508b9a27f41b760f$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var $508b9a27f41b760f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $508b9a27f41b760f$var$formatRelativeLocale[token];
};
var $508b9a27f41b760f$export$2e2bcd8739ae039 = $508b9a27f41b760f$var$formatRelative;

});

parcelRegister("kw7fy", function(module, exports) {
$parcel$export(module.exports, "default", () => $eefc6b77dc09c7c8$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $eefc6b77dc09c7c8$var$eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $eefc6b77dc09c7c8$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $eefc6b77dc09c7c8$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var $eefc6b77dc09c7c8$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var $eefc6b77dc09c7c8$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var $eefc6b77dc09c7c8$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var $eefc6b77dc09c7c8$var$localize = {
    ordinalNumber: $eefc6b77dc09c7c8$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $eefc6b77dc09c7c8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $eefc6b77dc09c7c8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $eefc6b77dc09c7c8$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $eefc6b77dc09c7c8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $eefc6b77dc09c7c8$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $eefc6b77dc09c7c8$export$2e2bcd8739ae039 = $eefc6b77dc09c7c8$var$localize;

});

parcelRegister("imIHH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5ecf54b1249ce76$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $d5ecf54b1249ce76$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $d5ecf54b1249ce76$var$parseOrdinalNumberPattern = /\d+/i;
var $d5ecf54b1249ce76$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $d5ecf54b1249ce76$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $d5ecf54b1249ce76$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $d5ecf54b1249ce76$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d5ecf54b1249ce76$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $d5ecf54b1249ce76$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $d5ecf54b1249ce76$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $d5ecf54b1249ce76$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $d5ecf54b1249ce76$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $d5ecf54b1249ce76$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $d5ecf54b1249ce76$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $d5ecf54b1249ce76$var$matchOrdinalNumberPattern,
        parsePattern: $d5ecf54b1249ce76$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $d5ecf54b1249ce76$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d5ecf54b1249ce76$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $d5ecf54b1249ce76$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d5ecf54b1249ce76$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $d5ecf54b1249ce76$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d5ecf54b1249ce76$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $d5ecf54b1249ce76$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d5ecf54b1249ce76$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $d5ecf54b1249ce76$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d5ecf54b1249ce76$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d5ecf54b1249ce76$export$2e2bcd8739ae039 = $d5ecf54b1249ce76$var$match;

});


parcelRegister("55wzU", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b46b0b607961296$export$2e2bcd8739ae039);

var $dz22u = parcelRequire("dz22u");

var $6gpPg = parcelRequire("6gpPg");

var $enkn8 = parcelRequire("enkn8");

var $dqTAy = parcelRequire("dqTAy");

var $dSQaI = parcelRequire("dSQaI");
/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var $3b46b0b607961296$var$locale = {
    code: 'hu',
    formatDistance: (0, $dz22u.default),
    formatLong: (0, $6gpPg.default),
    formatRelative: (0, $enkn8.default),
    localize: (0, $dqTAy.default),
    match: (0, $dSQaI.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $3b46b0b607961296$export$2e2bcd8739ae039 = $3b46b0b607961296$var$locale;

});
parcelRegister("dz22u", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e00203153bc3b99$export$2e2bcd8739ae039);
var $9e00203153bc3b99$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var $9e00203153bc3b99$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var $9e00203153bc3b99$var$withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
var $9e00203153bc3b99$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? $9e00203153bc3b99$var$withSuffixes[key][comparison] : $9e00203153bc3b99$var$withoutSuffixes[key];
    var result = key === 'halfaminute' ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = $9e00203153bc3b99$var$translations[adv] + ' ' + result;
    }
    return result;
};
var $9e00203153bc3b99$export$2e2bcd8739ae039 = $9e00203153bc3b99$var$formatDistance;

});

parcelRegister("6gpPg", function(module, exports) {
$parcel$export(module.exports, "default", () => $48f845328fb61761$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $48f845328fb61761$var$dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var $48f845328fb61761$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $48f845328fb61761$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $48f845328fb61761$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $48f845328fb61761$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $48f845328fb61761$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $48f845328fb61761$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $48f845328fb61761$export$2e2bcd8739ae039 = $48f845328fb61761$var$formatLong;

});

parcelRegister("enkn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7730422d7b36560$export$2e2bcd8739ae039);
var $a7730422d7b36560$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function $a7730422d7b36560$var$week(isFuture) {
    return function(date) {
        var weekday = $a7730422d7b36560$var$accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? '' : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var $a7730422d7b36560$var$formatRelativeLocale = {
    lastWeek: $a7730422d7b36560$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $a7730422d7b36560$var$week(true),
    other: 'P'
};
var $a7730422d7b36560$var$formatRelative = function formatRelative(token, date) {
    var format = $a7730422d7b36560$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $a7730422d7b36560$export$2e2bcd8739ae039 = $a7730422d7b36560$var$formatRelative;

});

parcelRegister("dqTAy", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c78d2d0e5789920$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $9c78d2d0e5789920$var$eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var $9c78d2d0e5789920$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var $9c78d2d0e5789920$var$formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var $9c78d2d0e5789920$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $9c78d2d0e5789920$var$dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var $9c78d2d0e5789920$var$dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
var $9c78d2d0e5789920$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $9c78d2d0e5789920$var$localize = {
    ordinalNumber: $9c78d2d0e5789920$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $9c78d2d0e5789920$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $9c78d2d0e5789920$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: $9c78d2d0e5789920$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide'
    }),
    month: (0, $nOHjC.default)({
        values: $9c78d2d0e5789920$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $9c78d2d0e5789920$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $9c78d2d0e5789920$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $9c78d2d0e5789920$export$2e2bcd8739ae039 = $9c78d2d0e5789920$var$localize;

});

parcelRegister("dSQaI", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1b8c9b990df08ef$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $a1b8c9b990df08ef$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $a1b8c9b990df08ef$var$parseOrdinalNumberPattern = /\d+/i;
var $a1b8c9b990df08ef$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var $a1b8c9b990df08ef$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var $a1b8c9b990df08ef$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var $a1b8c9b990df08ef$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var $a1b8c9b990df08ef$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var $a1b8c9b990df08ef$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a1b8c9b990df08ef$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var $a1b8c9b990df08ef$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var $a1b8c9b990df08ef$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var $a1b8c9b990df08ef$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var $a1b8c9b990df08ef$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $a1b8c9b990df08ef$var$matchOrdinalNumberPattern,
        parsePattern: $a1b8c9b990df08ef$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $a1b8c9b990df08ef$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1b8c9b990df08ef$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $a1b8c9b990df08ef$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1b8c9b990df08ef$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $a1b8c9b990df08ef$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1b8c9b990df08ef$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $a1b8c9b990df08ef$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1b8c9b990df08ef$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $a1b8c9b990df08ef$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a1b8c9b990df08ef$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a1b8c9b990df08ef$export$2e2bcd8739ae039 = $a1b8c9b990df08ef$var$match;

});


parcelRegister("6VfaH", function(module, exports) {
$parcel$export(module.exports, "default", () => $50a3d5b9cccb4660$export$2e2bcd8739ae039);

var $isoJo = parcelRequire("isoJo");

var $jIhBr = parcelRequire("jIhBr");

var $66t6l = parcelRequire("66t6l");

var $9U3fR = parcelRequire("9U3fR");

var $iH4wp = parcelRequire("iH4wp");
/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var $50a3d5b9cccb4660$var$locale = {
    code: 'is',
    formatDistance: (0, $isoJo.default),
    formatLong: (0, $jIhBr.default),
    formatRelative: (0, $66t6l.default),
    localize: (0, $9U3fR.default),
    match: (0, $iH4wp.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $50a3d5b9cccb4660$export$2e2bcd8739ae039 = $50a3d5b9cccb4660$var$locale;

});
parcelRegister("isoJo", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6fe069d0be521c0$export$2e2bcd8739ae039);
var $d6fe069d0be521c0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: '1 klukkustund',
        other: '{{count}} klukkustundir'
    },
    xDays: {
        one: '1 dagur',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'um viku',
        other: 'um {{count}} vikur'
    },
    xWeeks: {
        one: '1 viku',
        other: '{{count}} vikur'
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var $d6fe069d0be521c0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d6fe069d0be521c0$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
var $d6fe069d0be521c0$export$2e2bcd8739ae039 = $d6fe069d0be521c0$var$formatDistance;

});

parcelRegister("jIhBr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e59fc7f086f526f0$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $e59fc7f086f526f0$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'd.MM.y'
};
var $e59fc7f086f526f0$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e59fc7f086f526f0$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $e59fc7f086f526f0$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $e59fc7f086f526f0$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $e59fc7f086f526f0$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $e59fc7f086f526f0$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e59fc7f086f526f0$export$2e2bcd8739ae039 = $e59fc7f086f526f0$var$formatLong;

});

parcelRegister("66t6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $4719e0826e27f217$export$2e2bcd8739ae039);
var $4719e0826e27f217$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: 'P'
};
var $4719e0826e27f217$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4719e0826e27f217$var$formatRelativeLocale[token];
};
var $4719e0826e27f217$export$2e2bcd8739ae039 = $4719e0826e27f217$var$formatRelative;

});

parcelRegister("9U3fR", function(module, exports) {
$parcel$export(module.exports, "default", () => $735bde59a6edcbc2$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $735bde59a6edcbc2$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        'fyrir Krist',
        'eftir Krist'
    ]
};
var $735bde59a6edcbc2$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1F',
        '2F',
        '3F',
        '4F'
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var $735bde59a6edcbc2$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        "\xc1",
        'S',
        "\xd3",
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'sept.',
        'okt.',
        "n\xf3v.",
        'des.'
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'september',
        "okt\xf3ber",
        "n\xf3vember",
        'desember'
    ]
};
var $735bde59a6edcbc2$var$dayValues = {
    narrow: [
        'S',
        'M',
        "\xde",
        'M',
        'F',
        'F',
        'L'
    ],
    short: [
        'Su',
        "M\xe1",
        "\xder",
        'Mi',
        'Fi',
        "F\xf6",
        'La'
    ],
    abbreviated: [
        'sun.',
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        'fim.',
        "f\xf6s.",
        'lau.'
    ],
    wide: [
        'sunnudagur',
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        'fimmtudagur',
        "f\xf6studagur",
        'laugardagur'
    ]
};
var $735bde59a6edcbc2$var$dayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var $735bde59a6edcbc2$var$formattingDayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var $735bde59a6edcbc2$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $735bde59a6edcbc2$var$localize = {
    ordinalNumber: $735bde59a6edcbc2$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $735bde59a6edcbc2$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $735bde59a6edcbc2$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $735bde59a6edcbc2$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $735bde59a6edcbc2$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $735bde59a6edcbc2$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $735bde59a6edcbc2$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $735bde59a6edcbc2$export$2e2bcd8739ae039 = $735bde59a6edcbc2$var$localize;

});

parcelRegister("iH4wp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9bfc0143e3e14b6$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $d9bfc0143e3e14b6$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $d9bfc0143e3e14b6$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
var $d9bfc0143e3e14b6$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var $d9bfc0143e3e14b6$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var $d9bfc0143e3e14b6$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var $d9bfc0143e3e14b6$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var $d9bfc0143e3e14b6$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var $d9bfc0143e3e14b6$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var $d9bfc0143e3e14b6$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var $d9bfc0143e3e14b6$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var $d9bfc0143e3e14b6$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var $d9bfc0143e3e14b6$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var $d9bfc0143e3e14b6$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $d9bfc0143e3e14b6$var$matchOrdinalNumberPattern,
        parsePattern: $d9bfc0143e3e14b6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $d9bfc0143e3e14b6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d9bfc0143e3e14b6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $d9bfc0143e3e14b6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d9bfc0143e3e14b6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $d9bfc0143e3e14b6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d9bfc0143e3e14b6$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $d9bfc0143e3e14b6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d9bfc0143e3e14b6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $d9bfc0143e3e14b6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d9bfc0143e3e14b6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d9bfc0143e3e14b6$export$2e2bcd8739ae039 = $d9bfc0143e3e14b6$var$match;

});


parcelRegister("6oZdj", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a9477c20747ebb8$export$2e2bcd8739ae039);

var $hH6Ib = parcelRequire("hH6Ib");

var $gXyxC = parcelRequire("gXyxC");

var $51uRL = parcelRequire("51uRL");

var $2vYQl = parcelRequire("2vYQl");

var $2odnd = parcelRequire("2odnd");
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var $4a9477c20747ebb8$var$locale = {
    code: 'it',
    formatDistance: (0, $hH6Ib.default),
    formatLong: (0, $gXyxC.default),
    formatRelative: (0, $51uRL.default),
    localize: (0, $2vYQl.default),
    match: (0, $2odnd.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4a9477c20747ebb8$export$2e2bcd8739ae039 = $4a9477c20747ebb8$var$locale;

});
parcelRegister("hH6Ib", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce1ba89ddd6f74d8$export$2e2bcd8739ae039);
var $ce1ba89ddd6f74d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'meno di un secondo',
        other: 'meno di {{count}} secondi'
    },
    xSeconds: {
        one: 'un secondo',
        other: '{{count}} secondi'
    },
    halfAMinute: 'alcuni secondi',
    lessThanXMinutes: {
        one: 'meno di un minuto',
        other: 'meno di {{count}} minuti'
    },
    xMinutes: {
        one: 'un minuto',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "circa un'ora",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "un'ora",
        other: '{{count}} ore'
    },
    xDays: {
        one: 'un giorno',
        other: '{{count}} giorni'
    },
    aboutXWeeks: {
        one: 'circa una settimana',
        other: 'circa {{count}} settimane'
    },
    xWeeks: {
        one: 'una settimana',
        other: '{{count}} settimane'
    },
    aboutXMonths: {
        one: 'circa un mese',
        other: 'circa {{count}} mesi'
    },
    xMonths: {
        one: 'un mese',
        other: '{{count}} mesi'
    },
    aboutXYears: {
        one: 'circa un anno',
        other: 'circa {{count}} anni'
    },
    xYears: {
        one: 'un anno',
        other: '{{count}} anni'
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: 'quasi un anno',
        other: 'quasi {{count}} anni'
    }
};
var $ce1ba89ddd6f74d8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ce1ba89ddd6f74d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'tra ' + result;
        else return result + ' fa';
    }
    return result;
};
var $ce1ba89ddd6f74d8$export$2e2bcd8739ae039 = $ce1ba89ddd6f74d8$var$formatDistance;

});

parcelRegister("gXyxC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c58cf32fe69bf5cd$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $c58cf32fe69bf5cd$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $c58cf32fe69bf5cd$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c58cf32fe69bf5cd$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $c58cf32fe69bf5cd$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $c58cf32fe69bf5cd$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $c58cf32fe69bf5cd$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $c58cf32fe69bf5cd$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c58cf32fe69bf5cd$export$2e2bcd8739ae039 = $c58cf32fe69bf5cd$var$formatLong;

});

parcelRegister("51uRL", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a84fd1aedfd573a$export$2e2bcd8739ae039);

var $2yCTh = parcelRequire("2yCTh");
var $3a84fd1aedfd573a$var$weekdays = [
    'domenica',
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    'sabato'
];
function $3a84fd1aedfd573a$var$_lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $3a84fd1aedfd573a$var$weekdays[day] + " scorso alle' p";
    }
}
function $3a84fd1aedfd573a$var$thisWeek(day) {
    return "'" + $3a84fd1aedfd573a$var$weekdays[day] + " alle' p";
}
function $3a84fd1aedfd573a$var$_nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $3a84fd1aedfd573a$var$weekdays[day] + " prossimo alle' p";
    }
}
var $3a84fd1aedfd573a$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2yCTh.default)(date, baseDate, options)) return $3a84fd1aedfd573a$var$thisWeek(day);
        else return $3a84fd1aedfd573a$var$_lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2yCTh.default)(date, baseDate, options)) return $3a84fd1aedfd573a$var$thisWeek(day);
        else return $3a84fd1aedfd573a$var$_nextWeek(day);
    },
    other: 'P'
};
var $3a84fd1aedfd573a$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $3a84fd1aedfd573a$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $3a84fd1aedfd573a$export$2e2bcd8739ae039 = $3a84fd1aedfd573a$var$formatRelative;

});
parcelRegister("2yCTh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dccec9d2d49cc5b$export$2e2bcd8739ae039);

var $2JUk4 = parcelRequire("2JUk4");

var $aZdYd = parcelRequire("aZdYd");
function $1dccec9d2d49cc5b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $2JUk4.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $aZdYd.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $aZdYd.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});


parcelRegister("2vYQl", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d4dac39664d661d$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $1d4dac39664d661d$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'avanti Cristo',
        'dopo Cristo'
    ]
};
var $1d4dac39664d661d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $1d4dac39664d661d$var$monthValues = {
    narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic'
    ],
    wide: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre'
    ]
};
var $1d4dac39664d661d$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'G',
        'V',
        'S'
    ],
    short: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    wide: [
        'domenica',
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        'sabato'
    ]
};
var $1d4dac39664d661d$var$dayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    }
};
var $1d4dac39664d661d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    }
};
var $1d4dac39664d661d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var $1d4dac39664d661d$var$localize = {
    ordinalNumber: $1d4dac39664d661d$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $1d4dac39664d661d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $1d4dac39664d661d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $1d4dac39664d661d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $1d4dac39664d661d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $1d4dac39664d661d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1d4dac39664d661d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1d4dac39664d661d$export$2e2bcd8739ae039 = $1d4dac39664d661d$var$localize;

});

parcelRegister("2odnd", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bd8325aea15db07$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $1bd8325aea15db07$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $1bd8325aea15db07$var$parseOrdinalNumberPattern = /\d+/i;
var $1bd8325aea15db07$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var $1bd8325aea15db07$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var $1bd8325aea15db07$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $1bd8325aea15db07$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1bd8325aea15db07$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var $1bd8325aea15db07$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $1bd8325aea15db07$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var $1bd8325aea15db07$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var $1bd8325aea15db07$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var $1bd8325aea15db07$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var $1bd8325aea15db07$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $1bd8325aea15db07$var$matchOrdinalNumberPattern,
        parsePattern: $1bd8325aea15db07$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $1bd8325aea15db07$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1bd8325aea15db07$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $1bd8325aea15db07$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1bd8325aea15db07$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $1bd8325aea15db07$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1bd8325aea15db07$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $1bd8325aea15db07$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1bd8325aea15db07$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $1bd8325aea15db07$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $1bd8325aea15db07$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1bd8325aea15db07$export$2e2bcd8739ae039 = $1bd8325aea15db07$var$match;

});


parcelRegister("kJgeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1749aca69968299$export$2e2bcd8739ae039);

var $b2DbS = parcelRequire("b2DbS");

var $BR3m9 = parcelRequire("BR3m9");

var $4VPND = parcelRequire("4VPND");

var $eG3rA = parcelRequire("eG3rA");

var $fLMRz = parcelRequire("fLMRz");
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $f1749aca69968299$var$locale = {
    code: 'ja',
    formatDistance: (0, $b2DbS.default),
    formatLong: (0, $BR3m9.default),
    formatRelative: (0, $4VPND.default),
    localize: (0, $eG3rA.default),
    match: (0, $fLMRz.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f1749aca69968299$export$2e2bcd8739ae039 = $f1749aca69968299$var$locale;

});
parcelRegister("b2DbS", function(module, exports) {
$parcel$export(module.exports, "default", () => $809e48076e0939a9$export$2e2bcd8739ae039);
var $809e48076e0939a9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
var $809e48076e0939a9$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $809e48076e0939a9$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
var $809e48076e0939a9$export$2e2bcd8739ae039 = $809e48076e0939a9$var$formatDistance;

});

parcelRegister("BR3m9", function(module, exports) {
$parcel$export(module.exports, "default", () => $071c9c101d27c5e9$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $071c9c101d27c5e9$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $071c9c101d27c5e9$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $071c9c101d27c5e9$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $071c9c101d27c5e9$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $071c9c101d27c5e9$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $071c9c101d27c5e9$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $071c9c101d27c5e9$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $071c9c101d27c5e9$export$2e2bcd8739ae039 = $071c9c101d27c5e9$var$formatLong;

});

parcelRegister("4VPND", function(module, exports) {
$parcel$export(module.exports, "default", () => $3974aaa149cb2de1$export$2e2bcd8739ae039);
var $3974aaa149cb2de1$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: 'P'
};
var $3974aaa149cb2de1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3974aaa149cb2de1$var$formatRelativeLocale[token];
};
var $3974aaa149cb2de1$export$2e2bcd8739ae039 = $3974aaa149cb2de1$var$formatRelative;

});

parcelRegister("eG3rA", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaf7a8d039e5e5e7$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $aaf7a8d039e5e5e7$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var $aaf7a8d039e5e5e7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var $aaf7a8d039e5e5e7$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var $aaf7a8d039e5e5e7$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var $aaf7a8d039e5e5e7$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $aaf7a8d039e5e5e7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $aaf7a8d039e5e5e7$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u5E74");
        case 'quarter':
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case 'month':
            return "".concat(number, "\u6708");
        case 'week':
            return "\u7B2C".concat(number, "\u9031");
        case 'date':
            return "".concat(number, "\u65E5");
        case 'hour':
            return "".concat(number, "\u6642");
        case 'minute':
            return "".concat(number, "\u5206");
        case 'second':
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
};
var $aaf7a8d039e5e5e7$var$localize = {
    ordinalNumber: $aaf7a8d039e5e5e7$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $aaf7a8d039e5e5e7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $aaf7a8d039e5e5e7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $aaf7a8d039e5e5e7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $aaf7a8d039e5e5e7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $aaf7a8d039e5e5e7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $aaf7a8d039e5e5e7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $aaf7a8d039e5e5e7$export$2e2bcd8739ae039 = $aaf7a8d039e5e5e7$var$localize;

});

parcelRegister("fLMRz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7b125fda465e2e6$export$2e2bcd8739ae039);

var $ifMvQ = parcelRequire("ifMvQ");

var $5CeaO = parcelRequire("5CeaO");
var $b7b125fda465e2e6$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var $b7b125fda465e2e6$var$parseOrdinalNumberPattern = /\d+/i;
var $b7b125fda465e2e6$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var $b7b125fda465e2e6$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var $b7b125fda465e2e6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var $b7b125fda465e2e6$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $b7b125fda465e2e6$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var $b7b125fda465e2e6$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $b7b125fda465e2e6$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var $b7b125fda465e2e6$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var $b7b125fda465e2e6$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var $b7b125fda465e2e6$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var $b7b125fda465e2e6$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $b7b125fda465e2e6$var$matchOrdinalNumberPattern,
        parsePattern: $b7b125fda465e2e6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $b7b125fda465e2e6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7b125fda465e2e6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $b7b125fda465e2e6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7b125fda465e2e6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $b7b125fda465e2e6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7b125fda465e2e6$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $b7b125fda465e2e6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7b125fda465e2e6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $b7b125fda465e2e6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b7b125fda465e2e6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b7b125fda465e2e6$export$2e2bcd8739ae039 = $b7b125fda465e2e6$var$match;

});


parcelRegister("aH9lB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c952bc0ab3aeaa6$export$2e2bcd8739ae039);

var $8pK8t = parcelRequire("8pK8t");

var $8GozV = parcelRequire("8GozV");

var $atGXb = parcelRequire("atGXb");

var $bh3BA = parcelRequire("bh3BA");

var $1CX1D = parcelRequire("1CX1D");
/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $7c952bc0ab3aeaa6$var$locale = {
    code: 'ko',
    formatDistance: (0, $8pK8t.default),
    formatLong: (0, $8GozV.default),
    formatRelative: (0, $atGXb.default),
    localize: (0, $bh3BA.default),
    match: (0, $1CX1D.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $7c952bc0ab3aeaa6$export$2e2bcd8739ae039 = $7c952bc0ab3aeaa6$var$locale;

});
parcelRegister("8pK8t", function(module, exports) {
$parcel$export(module.exports, "default", () => $62047221b9dccd0c$export$2e2bcd8739ae039);
var $62047221b9dccd0c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
var $62047221b9dccd0c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $62047221b9dccd0c$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
var $62047221b9dccd0c$export$2e2bcd8739ae039 = $62047221b9dccd0c$var$formatDistance;

});

parcelRegister("8GozV", function(module, exports) {
$parcel$export(module.exports, "default", () => $65254fb976ae8af8$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $65254fb976ae8af8$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: 'y.MM.dd',
    short: 'y.MM.dd'
};
var $65254fb976ae8af8$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: 'a H:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $65254fb976ae8af8$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $65254fb976ae8af8$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $65254fb976ae8af8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $65254fb976ae8af8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $65254fb976ae8af8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $65254fb976ae8af8$export$2e2bcd8739ae039 = $65254fb976ae8af8$var$formatLong;

});

parcelRegister("atGXb", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a0dee81153033e8$export$2e2bcd8739ae039);
var $7a0dee81153033e8$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: 'P'
};
var $7a0dee81153033e8$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7a0dee81153033e8$var$formatRelativeLocale[token];
};
var $7a0dee81153033e8$export$2e2bcd8739ae039 = $7a0dee81153033e8$var$formatRelative;

});

parcelRegister("bh3BA", function(module, exports) {
$parcel$export(module.exports, "default", () => $83541427daffa0b7$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $83541427daffa0b7$var$eraValues = {
    narrow: [
        'BC',
        'AD'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var $83541427daffa0b7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var $83541427daffa0b7$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var $83541427daffa0b7$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var $83541427daffa0b7$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $83541427daffa0b7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $83541427daffa0b7$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'minute':
        case 'second':
            return String(number);
        case 'date':
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
var $83541427daffa0b7$var$localize = {
    ordinalNumber: $83541427daffa0b7$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $83541427daffa0b7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $83541427daffa0b7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $83541427daffa0b7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $83541427daffa0b7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $83541427daffa0b7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $83541427daffa0b7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $83541427daffa0b7$export$2e2bcd8739ae039 = $83541427daffa0b7$var$localize;

});

parcelRegister("1CX1D", function(module, exports) {
$parcel$export(module.exports, "default", () => $12f720498430e533$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $12f720498430e533$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var $12f720498430e533$var$parseOrdinalNumberPattern = /\d+/i;
var $12f720498430e533$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var $12f720498430e533$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var $12f720498430e533$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var $12f720498430e533$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $12f720498430e533$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var $12f720498430e533$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $12f720498430e533$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var $12f720498430e533$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var $12f720498430e533$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var $12f720498430e533$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var $12f720498430e533$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $12f720498430e533$var$matchOrdinalNumberPattern,
        parsePattern: $12f720498430e533$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $12f720498430e533$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $12f720498430e533$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $12f720498430e533$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $12f720498430e533$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $12f720498430e533$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $12f720498430e533$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $12f720498430e533$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $12f720498430e533$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $12f720498430e533$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $12f720498430e533$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $12f720498430e533$export$2e2bcd8739ae039 = $12f720498430e533$var$match;

});


parcelRegister("alD54", function(module, exports) {
$parcel$export(module.exports, "default", () => $788a2e2b3753b028$export$2e2bcd8739ae039);

var $5rgoh = parcelRequire("5rgoh");

var $lrMhm = parcelRequire("lrMhm");

var $lzrzX = parcelRequire("lzrzX");

var $61ciM = parcelRequire("61ciM");

var $iOjLH = parcelRequire("iOjLH");
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $788a2e2b3753b028$var$locale = {
    code: 'nb',
    formatDistance: (0, $5rgoh.default),
    formatLong: (0, $lrMhm.default),
    formatRelative: (0, $lzrzX.default),
    localize: (0, $61ciM.default),
    match: (0, $iOjLH.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $788a2e2b3753b028$export$2e2bcd8739ae039 = $788a2e2b3753b028$var$locale;

});
parcelRegister("5rgoh", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f5c302efe016726$export$2e2bcd8739ae039);
var $3f5c302efe016726$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn ett sekund',
        other: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        one: 'ett sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn ett minutt',
        other: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        one: 'ett minutt',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'omtrent en time',
        other: 'omtrent {{count}} timer'
    },
    xHours: {
        one: 'en time',
        other: '{{count}} timer'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dager'
    },
    aboutXWeeks: {
        one: 'omtrent en uke',
        other: 'omtrent {{count}} uker'
    },
    xWeeks: {
        one: 'en uke',
        other: '{{count}} uker'
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $3f5c302efe016726$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3f5c302efe016726$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $3f5c302efe016726$export$2e2bcd8739ae039 = $3f5c302efe016726$var$formatDistance;

});

parcelRegister("lrMhm", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9d191d121673005$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $f9d191d121673005$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $f9d191d121673005$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $f9d191d121673005$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $f9d191d121673005$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $f9d191d121673005$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $f9d191d121673005$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $f9d191d121673005$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f9d191d121673005$export$2e2bcd8739ae039 = $f9d191d121673005$var$formatLong;

});

parcelRegister("lzrzX", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb42427bb9e97f5f$export$2e2bcd8739ae039);
var $fb42427bb9e97f5f$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $fb42427bb9e97f5f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $fb42427bb9e97f5f$var$formatRelativeLocale[token];
};
var $fb42427bb9e97f5f$export$2e2bcd8739ae039 = $fb42427bb9e97f5f$var$formatRelative;

});

parcelRegister("61ciM", function(module, exports) {
$parcel$export(module.exports, "default", () => $461c60ff1d1cc3e8$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $461c60ff1d1cc3e8$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $461c60ff1d1cc3e8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $461c60ff1d1cc3e8$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $461c60ff1d1cc3e8$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $461c60ff1d1cc3e8$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var $461c60ff1d1cc3e8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $461c60ff1d1cc3e8$var$localize = {
    ordinalNumber: $461c60ff1d1cc3e8$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $461c60ff1d1cc3e8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $461c60ff1d1cc3e8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $461c60ff1d1cc3e8$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $461c60ff1d1cc3e8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $461c60ff1d1cc3e8$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $461c60ff1d1cc3e8$export$2e2bcd8739ae039 = $461c60ff1d1cc3e8$var$localize;

});

parcelRegister("iOjLH", function(module, exports) {
$parcel$export(module.exports, "default", () => $db1c3b13a62aa3c0$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $db1c3b13a62aa3c0$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $db1c3b13a62aa3c0$var$parseOrdinalNumberPattern = /\d+/i;
var $db1c3b13a62aa3c0$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $db1c3b13a62aa3c0$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $db1c3b13a62aa3c0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $db1c3b13a62aa3c0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $db1c3b13a62aa3c0$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $db1c3b13a62aa3c0$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $db1c3b13a62aa3c0$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $db1c3b13a62aa3c0$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $db1c3b13a62aa3c0$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $db1c3b13a62aa3c0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $db1c3b13a62aa3c0$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $db1c3b13a62aa3c0$var$matchOrdinalNumberPattern,
        parsePattern: $db1c3b13a62aa3c0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $db1c3b13a62aa3c0$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $db1c3b13a62aa3c0$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $db1c3b13a62aa3c0$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $db1c3b13a62aa3c0$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $db1c3b13a62aa3c0$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $db1c3b13a62aa3c0$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $db1c3b13a62aa3c0$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $db1c3b13a62aa3c0$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $db1c3b13a62aa3c0$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $db1c3b13a62aa3c0$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $db1c3b13a62aa3c0$export$2e2bcd8739ae039 = $db1c3b13a62aa3c0$var$match;

});


parcelRegister("6xxA1", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c2fdf74bd07e71b$export$2e2bcd8739ae039);

var $kTv8L = parcelRequire("kTv8L");

var $eeJd9 = parcelRequire("eeJd9");

var $hY0Xe = parcelRequire("hY0Xe");

var $6nRgM = parcelRequire("6nRgM");

var $bEJZ7 = parcelRequire("bEJZ7");
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var $4c2fdf74bd07e71b$var$locale = {
    code: 'nl',
    formatDistance: (0, $kTv8L.default),
    formatLong: (0, $eeJd9.default),
    formatRelative: (0, $hY0Xe.default),
    localize: (0, $6nRgM.default),
    match: (0, $bEJZ7.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4c2fdf74bd07e71b$export$2e2bcd8739ae039 = $4c2fdf74bd07e71b$var$locale;

});
parcelRegister("kTv8L", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3611980be227ced$export$2e2bcd8739ae039);
var $f3611980be227ced$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var $f3611980be227ced$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f3611980be227ced$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
var $f3611980be227ced$export$2e2bcd8739ae039 = $f3611980be227ced$var$formatDistance;

});

parcelRegister("eeJd9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5d5717fb71cdda2$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $a5d5717fb71cdda2$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $a5d5717fb71cdda2$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $a5d5717fb71cdda2$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a5d5717fb71cdda2$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $a5d5717fb71cdda2$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $a5d5717fb71cdda2$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $a5d5717fb71cdda2$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a5d5717fb71cdda2$export$2e2bcd8739ae039 = $a5d5717fb71cdda2$var$formatLong;

});

parcelRegister("hY0Xe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d148c7cae77bf514$export$2e2bcd8739ae039);
var $d148c7cae77bf514$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $d148c7cae77bf514$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d148c7cae77bf514$var$formatRelativeLocale[token];
};
var $d148c7cae77bf514$export$2e2bcd8739ae039 = $d148c7cae77bf514$var$formatRelative;

});

parcelRegister("6nRgM", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a5e3651eb94affc$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $4a5e3651eb94affc$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $4a5e3651eb94affc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $4a5e3651eb94affc$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $4a5e3651eb94affc$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $4a5e3651eb94affc$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $4a5e3651eb94affc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $4a5e3651eb94affc$var$localize = {
    ordinalNumber: $4a5e3651eb94affc$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $4a5e3651eb94affc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $4a5e3651eb94affc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $4a5e3651eb94affc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $4a5e3651eb94affc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $4a5e3651eb94affc$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $4a5e3651eb94affc$export$2e2bcd8739ae039 = $4a5e3651eb94affc$var$localize;

});

parcelRegister("bEJZ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $87c719c3879fe103$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $87c719c3879fe103$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $87c719c3879fe103$var$parseOrdinalNumberPattern = /\d+/i;
var $87c719c3879fe103$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $87c719c3879fe103$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $87c719c3879fe103$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $87c719c3879fe103$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $87c719c3879fe103$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $87c719c3879fe103$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $87c719c3879fe103$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $87c719c3879fe103$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $87c719c3879fe103$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $87c719c3879fe103$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $87c719c3879fe103$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $87c719c3879fe103$var$matchOrdinalNumberPattern,
        parsePattern: $87c719c3879fe103$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $87c719c3879fe103$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $87c719c3879fe103$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $87c719c3879fe103$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $87c719c3879fe103$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $87c719c3879fe103$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $87c719c3879fe103$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $87c719c3879fe103$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $87c719c3879fe103$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $87c719c3879fe103$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $87c719c3879fe103$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $87c719c3879fe103$export$2e2bcd8739ae039 = $87c719c3879fe103$var$match;

});


parcelRegister("hXSJY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d14268aedd63463d$export$2e2bcd8739ae039);

var $igqaC = parcelRequire("igqaC");

var $gJinj = parcelRequire("gJinj");

var $1h7PN = parcelRequire("1h7PN");

var $amwue = parcelRequire("amwue");

var $dW8pO = parcelRequire("dW8pO");
/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var $d14268aedd63463d$var$locale = {
    code: 'pl',
    formatDistance: (0, $igqaC.default),
    formatLong: (0, $gJinj.default),
    formatRelative: (0, $1h7PN.default),
    localize: (0, $amwue.default),
    match: (0, $dW8pO.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d14268aedd63463d$export$2e2bcd8739ae039 = $d14268aedd63463d$var$locale;

});
parcelRegister("igqaC", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4be057a820f316b$export$2e2bcd8739ae039);
var $d4be057a820f316b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: '{{count}} sekundy',
        other: '{{count}} sekund'
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: '{{count}} minuty',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: 'godzina',
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: '{{count}} godziny',
        other: '{{count}} godzin'
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: '{{count}} dni',
        other: '{{count}} dni'
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: '{{count}} tygodnie',
        other: '{{count}} tygodni'
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: 'rok',
        twoFour: '{{count}} lata',
        other: '{{count}} lat'
    },
    overXYears: {
        one: 'ponad rok',
        twoFour: 'ponad {{count}} lata',
        other: 'ponad {{count}} lat'
    },
    almostXYears: {
        one: 'prawie rok',
        twoFour: 'prawie {{count}} lata',
        other: 'prawie {{count}} lat'
    }
};
function $d4be057a820f316b$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $d4be057a820f316b$var$declension(scheme, count, time) {
    var group = $d4be057a820f316b$var$declensionGroup(scheme, count);
    var finalText = typeof group === 'string' ? group : group[time];
    return finalText.replace('{{count}}', String(count));
}
var $d4be057a820f316b$var$formatDistance = function formatDistance(token, count, options) {
    var scheme = $d4be057a820f316b$var$formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $d4be057a820f316b$var$declension(scheme, count, 'regular');
    if (options.comparison && options.comparison > 0) return 'za ' + $d4be057a820f316b$var$declension(scheme, count, 'future');
    else return $d4be057a820f316b$var$declension(scheme, count, 'past') + ' temu';
};
var $d4be057a820f316b$export$2e2bcd8739ae039 = $d4be057a820f316b$var$formatDistance;

});

parcelRegister("gJinj", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2df1a31db978110$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $c2df1a31db978110$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'dd.MM.y'
};
var $c2df1a31db978110$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c2df1a31db978110$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c2df1a31db978110$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $c2df1a31db978110$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $c2df1a31db978110$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $c2df1a31db978110$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c2df1a31db978110$export$2e2bcd8739ae039 = $c2df1a31db978110$var$formatLong;

});

parcelRegister("1h7PN", function(module, exports) {
$parcel$export(module.exports, "default", () => $0edd74bd889f3f68$export$2e2bcd8739ae039);

var $2yCTh = parcelRequire("2yCTh");
var $0edd74bd889f3f68$var$adjectivesLastWeek = {
    masculine: 'ostatni',
    feminine: 'ostatnia'
};
var $0edd74bd889f3f68$var$adjectivesThisWeek = {
    masculine: 'ten',
    feminine: 'ta'
};
var $0edd74bd889f3f68$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var $0edd74bd889f3f68$var$dayGrammaticalGender = {
    0: 'feminine',
    1: 'masculine',
    2: 'masculine',
    3: 'feminine',
    4: 'masculine',
    5: 'masculine',
    6: 'feminine'
};
function $0edd74bd889f3f68$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, $2yCTh.default)(date, baseDate, options)) adjectives = $0edd74bd889f3f68$var$adjectivesThisWeek;
    else if (token === 'lastWeek') adjectives = $0edd74bd889f3f68$var$adjectivesLastWeek;
    else if (token === 'nextWeek') adjectives = $0edd74bd889f3f68$var$adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = $0edd74bd889f3f68$var$dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var $0edd74bd889f3f68$var$formatRelativeLocale = {
    lastWeek: $0edd74bd889f3f68$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $0edd74bd889f3f68$var$dayAndTimeWithAdjective,
    other: 'P'
};
var $0edd74bd889f3f68$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $0edd74bd889f3f68$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(token, date, baseDate, options);
    return format;
};
var $0edd74bd889f3f68$export$2e2bcd8739ae039 = $0edd74bd889f3f68$var$formatRelative;

});

parcelRegister("amwue", function(module, exports) {
$parcel$export(module.exports, "default", () => $78b528a2632afb36$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $78b528a2632afb36$var$eraValues = {
    narrow: [
        'p.n.e.',
        'n.e.'
    ],
    abbreviated: [
        'p.n.e.',
        'n.e.'
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        'naszej ery'
    ]
};
var $78b528a2632afb36$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I kw.',
        'II kw.',
        'III kw.',
        'IV kw.'
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var $78b528a2632afb36$var$monthValues = {
    narrow: [
        'S',
        'L',
        'M',
        'K',
        'M',
        'C',
        'L',
        'S',
        'W',
        'P',
        'L',
        'G'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        "stycze\u0144",
        'luty',
        'marzec',
        "kwiecie\u0144",
        'maj',
        'czerwiec',
        'lipiec',
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        'listopad',
        "grudzie\u0144"
    ]
};
var $78b528a2632afb36$var$monthFormattingValues = {
    narrow: [
        's',
        'l',
        'm',
        'k',
        'm',
        'c',
        'l',
        's',
        'w',
        'p',
        'l',
        'g'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        'listopada',
        'grudnia'
    ]
};
var $78b528a2632afb36$var$dayValues = {
    narrow: [
        'N',
        'P',
        'W',
        "\u015A",
        'C',
        'P',
        'S'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $78b528a2632afb36$var$dayFormattingValues = {
    narrow: [
        'n',
        'p',
        'w',
        "\u015B",
        'c',
        'p',
        's'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $78b528a2632afb36$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: 'rano',
        afternoon: "popo\u0142.",
        evening: 'wiecz.',
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    }
};
var $78b528a2632afb36$var$dayPeriodFormattingValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: 'rano',
        afternoon: "po po\u0142.",
        evening: 'wiecz.',
        night: 'w nocy'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    }
};
var $78b528a2632afb36$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $78b528a2632afb36$var$localize = {
    ordinalNumber: $78b528a2632afb36$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $78b528a2632afb36$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $78b528a2632afb36$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $78b528a2632afb36$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $78b528a2632afb36$var$monthFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $78b528a2632afb36$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $78b528a2632afb36$var$dayFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $78b528a2632afb36$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $78b528a2632afb36$var$dayPeriodFormattingValues,
        defaultFormattingWidth: 'wide'
    })
};
var $78b528a2632afb36$export$2e2bcd8739ae039 = $78b528a2632afb36$var$localize;

});

parcelRegister("dW8pO", function(module, exports) {
$parcel$export(module.exports, "default", () => $a257383e5f118440$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $a257383e5f118440$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $a257383e5f118440$var$parseOrdinalNumberPattern = /\d+/i;
var $a257383e5f118440$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var $a257383e5f118440$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var $a257383e5f118440$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var $a257383e5f118440$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var $a257383e5f118440$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var $a257383e5f118440$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var $a257383e5f118440$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var $a257383e5f118440$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var $a257383e5f118440$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var $a257383e5f118440$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var $a257383e5f118440$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $a257383e5f118440$var$matchOrdinalNumberPattern,
        parsePattern: $a257383e5f118440$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $a257383e5f118440$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a257383e5f118440$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $a257383e5f118440$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a257383e5f118440$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $a257383e5f118440$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a257383e5f118440$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $a257383e5f118440$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a257383e5f118440$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $a257383e5f118440$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a257383e5f118440$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a257383e5f118440$export$2e2bcd8739ae039 = $a257383e5f118440$var$match;

});


parcelRegister("amj6a", function(module, exports) {
$parcel$export(module.exports, "default", () => $78aac6014aa8d9d7$export$2e2bcd8739ae039);

var $2F34P = parcelRequire("2F34P");

var $7lIqh = parcelRequire("7lIqh");

var $b7iO1 = parcelRequire("b7iO1");

var $cfYoH = parcelRequire("cfYoH");

var $j0MjF = parcelRequire("j0MjF");
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var $78aac6014aa8d9d7$var$locale = {
    code: 'pt',
    formatDistance: (0, $2F34P.default),
    formatLong: (0, $7lIqh.default),
    formatRelative: (0, $b7iO1.default),
    localize: (0, $cfYoH.default),
    match: (0, $j0MjF.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $78aac6014aa8d9d7$export$2e2bcd8739ae039 = $78aac6014aa8d9d7$var$locale;

});
parcelRegister("2F34P", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f01cc1695eaed0c$export$2e2bcd8739ae039);
var $1f01cc1695eaed0c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'aproximadamente 1 semana',
        other: 'aproximadamente {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: 'aproximadamente {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $1f01cc1695eaed0c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1f01cc1695eaed0c$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'daqui a ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $1f01cc1695eaed0c$export$2e2bcd8739ae039 = $1f01cc1695eaed0c$var$formatDistance;

});

parcelRegister("7lIqh", function(module, exports) {
$parcel$export(module.exports, "default", () => $559cf408bad135d8$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $559cf408bad135d8$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: 'dd/MM/y'
};
var $559cf408bad135d8$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $559cf408bad135d8$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $559cf408bad135d8$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $559cf408bad135d8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $559cf408bad135d8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $559cf408bad135d8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $559cf408bad135d8$export$2e2bcd8739ae039 = $559cf408bad135d8$var$formatLong;

});

parcelRegister("b7iO1", function(module, exports) {
$parcel$export(module.exports, "default", () => $817eef9e95a89a48$export$2e2bcd8739ae039);
var $817eef9e95a89a48$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $817eef9e95a89a48$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $817eef9e95a89a48$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $817eef9e95a89a48$export$2e2bcd8739ae039 = $817eef9e95a89a48$var$formatRelative;

});

parcelRegister("cfYoH", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ec5bc694c4585f6$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $8ec5bc694c4585f6$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'antes de Cristo',
        'depois de Cristo'
    ]
};
var $8ec5bc694c4585f6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $8ec5bc694c4585f6$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $8ec5bc694c4585f6$var$dayValues = {
    narrow: [
        'd',
        's',
        't',
        'q',
        'q',
        's',
        's'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    abbreviated: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $8ec5bc694c4585f6$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    }
};
var $8ec5bc694c4585f6$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    }
};
var $8ec5bc694c4585f6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $8ec5bc694c4585f6$var$localize = {
    ordinalNumber: $8ec5bc694c4585f6$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $8ec5bc694c4585f6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $8ec5bc694c4585f6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $8ec5bc694c4585f6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $8ec5bc694c4585f6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $8ec5bc694c4585f6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8ec5bc694c4585f6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8ec5bc694c4585f6$export$2e2bcd8739ae039 = $8ec5bc694c4585f6$var$localize;

});

parcelRegister("j0MjF", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd737effcbb76cb9$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $dd737effcbb76cb9$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var $dd737effcbb76cb9$var$parseOrdinalNumberPattern = /\d+/i;
var $dd737effcbb76cb9$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var $dd737effcbb76cb9$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var $dd737effcbb76cb9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var $dd737effcbb76cb9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $dd737effcbb76cb9$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $dd737effcbb76cb9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $dd737effcbb76cb9$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var $dd737effcbb76cb9$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var $dd737effcbb76cb9$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var $dd737effcbb76cb9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var $dd737effcbb76cb9$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $dd737effcbb76cb9$var$matchOrdinalNumberPattern,
        parsePattern: $dd737effcbb76cb9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $dd737effcbb76cb9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd737effcbb76cb9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $dd737effcbb76cb9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd737effcbb76cb9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $dd737effcbb76cb9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd737effcbb76cb9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $dd737effcbb76cb9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd737effcbb76cb9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $dd737effcbb76cb9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $dd737effcbb76cb9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $dd737effcbb76cb9$export$2e2bcd8739ae039 = $dd737effcbb76cb9$var$match;

});


parcelRegister("fy4uR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b51d84f877d38666$export$2e2bcd8739ae039);

var $7on63 = parcelRequire("7on63");

var $6bEzW = parcelRequire("6bEzW");

var $8228U = parcelRequire("8228U");

var $1IcdN = parcelRequire("1IcdN");

var $cjOrC = parcelRequire("cjOrC");
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var $b51d84f877d38666$var$locale = {
    code: 'pt-BR',
    formatDistance: (0, $7on63.default),
    formatLong: (0, $6bEzW.default),
    formatRelative: (0, $8228U.default),
    localize: (0, $1IcdN.default),
    match: (0, $cjOrC.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b51d84f877d38666$export$2e2bcd8739ae039 = $b51d84f877d38666$var$locale;

});
parcelRegister("7on63", function(module, exports) {
$parcel$export(module.exports, "default", () => $561cb0d23f1a1d54$export$2e2bcd8739ae039);
var $561cb0d23f1a1d54$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'cerca de 1 hora',
        other: 'cerca de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'cerca de 1 semana',
        other: 'cerca de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: 'cerca de {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'cerca de 1 ano',
        other: 'cerca de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $561cb0d23f1a1d54$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $561cb0d23f1a1d54$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'em ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $561cb0d23f1a1d54$export$2e2bcd8739ae039 = $561cb0d23f1a1d54$var$formatDistance;

});

parcelRegister("6bEzW", function(module, exports) {
$parcel$export(module.exports, "default", () => $48133f4070b3ec99$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $48133f4070b3ec99$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $48133f4070b3ec99$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $48133f4070b3ec99$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $48133f4070b3ec99$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $48133f4070b3ec99$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $48133f4070b3ec99$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $48133f4070b3ec99$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $48133f4070b3ec99$export$2e2bcd8739ae039 = $48133f4070b3ec99$var$formatLong;

});

parcelRegister("8228U", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d902c1c52ce325a$export$2e2bcd8739ae039);
var $5d902c1c52ce325a$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $5d902c1c52ce325a$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $5d902c1c52ce325a$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $5d902c1c52ce325a$export$2e2bcd8739ae039 = $5d902c1c52ce325a$var$formatRelative;

});

parcelRegister("1IcdN", function(module, exports) {
$parcel$export(module.exports, "default", () => $13f36176b540e07c$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $13f36176b540e07c$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'depois de cristo'
    ]
};
var $13f36176b540e07c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $13f36176b540e07c$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $13f36176b540e07c$var$dayValues = {
    narrow: [
        'D',
        'S',
        'T',
        'Q',
        'Q',
        'S',
        'S'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        'sab'
    ],
    abbreviated: [
        'domingo',
        'segunda',
        "ter\xe7a",
        'quarta',
        'quinta',
        'sexta',
        "s\xe1bado"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $13f36176b540e07c$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    }
};
var $13f36176b540e07c$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    }
};
var $13f36176b540e07c$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') return number + "\xaa";
    return number + "\xba";
};
var $13f36176b540e07c$var$localize = {
    ordinalNumber: $13f36176b540e07c$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $13f36176b540e07c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $13f36176b540e07c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $13f36176b540e07c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $13f36176b540e07c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $13f36176b540e07c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $13f36176b540e07c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $13f36176b540e07c$export$2e2bcd8739ae039 = $13f36176b540e07c$var$localize;

});

parcelRegister("cjOrC", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f7e639cce2a9221$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $8f7e639cce2a9221$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var $8f7e639cce2a9221$var$parseOrdinalNumberPattern = /\d+/i;
var $8f7e639cce2a9221$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var $8f7e639cce2a9221$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var $8f7e639cce2a9221$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $8f7e639cce2a9221$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8f7e639cce2a9221$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $8f7e639cce2a9221$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var $8f7e639cce2a9221$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var $8f7e639cce2a9221$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var $8f7e639cce2a9221$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var $8f7e639cce2a9221$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var $8f7e639cce2a9221$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $8f7e639cce2a9221$var$matchOrdinalNumberPattern,
        parsePattern: $8f7e639cce2a9221$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $8f7e639cce2a9221$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8f7e639cce2a9221$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $8f7e639cce2a9221$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8f7e639cce2a9221$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $8f7e639cce2a9221$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8f7e639cce2a9221$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $8f7e639cce2a9221$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8f7e639cce2a9221$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $8f7e639cce2a9221$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8f7e639cce2a9221$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8f7e639cce2a9221$export$2e2bcd8739ae039 = $8f7e639cce2a9221$var$match;

});


parcelRegister("3SLOA", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d3b814e7690418d$export$2e2bcd8739ae039);

var $htokC = parcelRequire("htokC");

var $hlAdT = parcelRequire("hlAdT");

var $chcSi = parcelRequire("chcSi");

var $8IaH0 = parcelRequire("8IaH0");

var $iTWkw = parcelRequire("iTWkw");
/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var $2d3b814e7690418d$var$locale = {
    code: 'ro',
    formatDistance: (0, $htokC.default),
    formatLong: (0, $hlAdT.default),
    formatRelative: (0, $chcSi.default),
    localize: (0, $8IaH0.default),
    match: (0, $iTWkw.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $2d3b814e7690418d$export$2e2bcd8739ae039 = $2d3b814e7690418d$var$locale;

});
parcelRegister("htokC", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb8804ddce4dd360$export$2e2bcd8739ae039);
var $cb8804ddce4dd360$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: '{{count}} secunde'
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "1 or\u0103",
        other: '{{count}} ore'
    },
    xDays: {
        one: '1 zi',
        other: '{{count}} zile'
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: 'circa {{count}} luni'
    },
    xMonths: {
        one: "1 lun\u0103",
        other: '{{count}} luni'
    },
    aboutXYears: {
        one: 'circa 1 an',
        other: 'circa {{count}} ani'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ani'
    },
    overXYears: {
        one: 'peste 1 an',
        other: 'peste {{count}} ani'
    },
    almostXYears: {
        one: 'aproape 1 an',
        other: 'aproape {{count}} ani'
    }
};
var $cb8804ddce4dd360$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $cb8804ddce4dd360$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
var $cb8804ddce4dd360$export$2e2bcd8739ae039 = $cb8804ddce4dd360$var$formatDistance;

});

parcelRegister("hlAdT", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca107ef8a897cc28$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $ca107ef8a897cc28$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd.MM.yyyy'
};
var $ca107ef8a897cc28$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ca107ef8a897cc28$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $ca107ef8a897cc28$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $ca107ef8a897cc28$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $ca107ef8a897cc28$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $ca107ef8a897cc28$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ca107ef8a897cc28$export$2e2bcd8739ae039 = $ca107ef8a897cc28$var$formatLong;

});

parcelRegister("chcSi", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f010f34f563a95c$export$2e2bcd8739ae039);
var $8f010f34f563a95c$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: 'P'
};
var $8f010f34f563a95c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $8f010f34f563a95c$var$formatRelativeLocale[token];
};
var $8f010f34f563a95c$export$2e2bcd8739ae039 = $8f010f34f563a95c$var$formatRelative;

});

parcelRegister("8IaH0", function(module, exports) {
$parcel$export(module.exports, "default", () => $657aba22b5b56961$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $657aba22b5b56961$var$eraValues = {
    narrow: [
        "\xce",
        'D'
    ],
    abbreviated: [
        "\xce.d.C.",
        'D.C.'
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var $657aba22b5b56961$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        'primul trimestru',
        'al doilea trimestru',
        'al treilea trimestru',
        'al patrulea trimestru'
    ]
};
var $657aba22b5b56961$var$monthValues = {
    narrow: [
        'I',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'ian',
        'feb',
        'mar',
        'apr',
        'mai',
        'iun',
        'iul',
        'aug',
        'sep',
        'oct',
        'noi',
        'dec'
    ],
    wide: [
        'ianuarie',
        'februarie',
        'martie',
        'aprilie',
        'mai',
        'iunie',
        'iulie',
        'august',
        'septembrie',
        'octombrie',
        'noiembrie',
        'decembrie'
    ]
};
var $657aba22b5b56961$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'du',
        'lu',
        'ma',
        'mi',
        'jo',
        'vi',
        "s\xe2"
    ],
    abbreviated: [
        'dum',
        'lun',
        'mar',
        'mie',
        'joi',
        'vin',
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        'luni',
        "mar\u021Bi",
        'miercuri',
        'joi',
        'vineri',
        "s\xe2mb\u0103t\u0103"
    ]
};
var $657aba22b5b56961$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'ami',
        morning: 'dim',
        afternoon: 'da',
        evening: 's',
        night: 'n'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $657aba22b5b56961$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $657aba22b5b56961$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $657aba22b5b56961$var$localize = {
    ordinalNumber: $657aba22b5b56961$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $657aba22b5b56961$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $657aba22b5b56961$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $657aba22b5b56961$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $657aba22b5b56961$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $657aba22b5b56961$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $657aba22b5b56961$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $657aba22b5b56961$export$2e2bcd8739ae039 = $657aba22b5b56961$var$localize;

});

parcelRegister("iTWkw", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc2a9c26a34d9af0$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $dc2a9c26a34d9af0$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $dc2a9c26a34d9af0$var$parseOrdinalNumberPattern = /\d+/i;
var $dc2a9c26a34d9af0$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var $dc2a9c26a34d9af0$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var $dc2a9c26a34d9af0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var $dc2a9c26a34d9af0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $dc2a9c26a34d9af0$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var $dc2a9c26a34d9af0$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $dc2a9c26a34d9af0$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var $dc2a9c26a34d9af0$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var $dc2a9c26a34d9af0$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var $dc2a9c26a34d9af0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var $dc2a9c26a34d9af0$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $dc2a9c26a34d9af0$var$matchOrdinalNumberPattern,
        parsePattern: $dc2a9c26a34d9af0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $dc2a9c26a34d9af0$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc2a9c26a34d9af0$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $dc2a9c26a34d9af0$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc2a9c26a34d9af0$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $dc2a9c26a34d9af0$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc2a9c26a34d9af0$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $dc2a9c26a34d9af0$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc2a9c26a34d9af0$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $dc2a9c26a34d9af0$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $dc2a9c26a34d9af0$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $dc2a9c26a34d9af0$export$2e2bcd8739ae039 = $dc2a9c26a34d9af0$var$match;

});


parcelRegister("4jMb5", function(module, exports) {
$parcel$export(module.exports, "default", () => $324e4ee4e2d30e23$export$2e2bcd8739ae039);

var $fj6jw = parcelRequire("fj6jw");

var $1SFDL = parcelRequire("1SFDL");

var $80zHu = parcelRequire("80zHu");

var $ijBpk = parcelRequire("ijBpk");

var $egbBU = parcelRequire("egbBU");
/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $324e4ee4e2d30e23$var$locale = {
    code: 'ru',
    formatDistance: (0, $fj6jw.default),
    formatLong: (0, $1SFDL.default),
    formatRelative: (0, $80zHu.default),
    localize: (0, $ijBpk.default),
    match: (0, $egbBU.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $324e4ee4e2d30e23$export$2e2bcd8739ae039 = $324e4ee4e2d30e23$var$locale;

});
parcelRegister("fj6jw", function(module, exports) {
$parcel$export(module.exports, "default", () => $b24d872805a2db1e$export$2e2bcd8739ae039);
function $b24d872805a2db1e$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $b24d872805a2db1e$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $b24d872805a2db1e$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $b24d872805a2db1e$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $b24d872805a2db1e$var$declension(scheme.past, count);
                else return $b24d872805a2db1e$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $b24d872805a2db1e$var$declension(scheme.regular, count);
    };
}
var $b24d872805a2db1e$var$formatDistanceLocale = {
    lessThanXSeconds: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $b24d872805a2db1e$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
var $b24d872805a2db1e$var$formatDistance = function formatDistance(token, count, options) {
    return $b24d872805a2db1e$var$formatDistanceLocale[token](count, options);
};
var $b24d872805a2db1e$export$2e2bcd8739ae039 = $b24d872805a2db1e$var$formatDistance;

});

parcelRegister("1SFDL", function(module, exports) {
$parcel$export(module.exports, "default", () => $15eb228353c89f8a$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $15eb228353c89f8a$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $15eb228353c89f8a$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $15eb228353c89f8a$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $15eb228353c89f8a$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $15eb228353c89f8a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $15eb228353c89f8a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $15eb228353c89f8a$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $15eb228353c89f8a$export$2e2bcd8739ae039 = $15eb228353c89f8a$var$formatLong;

});

parcelRegister("80zHu", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d4a042ba57451ea$export$2e2bcd8739ae039);

var $2yCTh = parcelRequire("2yCTh");
var $5d4a042ba57451ea$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $5d4a042ba57451ea$var$_lastWeek(day) {
    var weekday = $5d4a042ba57451ea$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $5d4a042ba57451ea$var$thisWeek(day) {
    var weekday = $5d4a042ba57451ea$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $5d4a042ba57451ea$var$_nextWeek(day) {
    var weekday = $5d4a042ba57451ea$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var $5d4a042ba57451ea$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2yCTh.default)(date, baseDate, options)) return $5d4a042ba57451ea$var$thisWeek(day);
        else return $5d4a042ba57451ea$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2yCTh.default)(date, baseDate, options)) return $5d4a042ba57451ea$var$thisWeek(day);
        else return $5d4a042ba57451ea$var$_nextWeek(day);
    },
    other: 'P'
};
var $5d4a042ba57451ea$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $5d4a042ba57451ea$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $5d4a042ba57451ea$export$2e2bcd8739ae039 = $5d4a042ba57451ea$var$formatRelative;

});

parcelRegister("ijBpk", function(module, exports) {
$parcel$export(module.exports, "default", () => $d55704b5d848bc57$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $d55704b5d848bc57$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var $d55704b5d848bc57$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $d55704b5d848bc57$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var $d55704b5d848bc57$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var $d55704b5d848bc57$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var $d55704b5d848bc57$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var $d55704b5d848bc57$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
var $d55704b5d848bc57$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'date') suffix = "-\u0435";
    else if (unit === 'week' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
var $d55704b5d848bc57$var$localize = {
    ordinalNumber: $d55704b5d848bc57$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $d55704b5d848bc57$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $d55704b5d848bc57$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $d55704b5d848bc57$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $d55704b5d848bc57$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $d55704b5d848bc57$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $d55704b5d848bc57$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $d55704b5d848bc57$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d55704b5d848bc57$export$2e2bcd8739ae039 = $d55704b5d848bc57$var$localize;

});

parcelRegister("egbBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a61b90e29ba617c8$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $a61b90e29ba617c8$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var $a61b90e29ba617c8$var$parseOrdinalNumberPattern = /\d+/i;
var $a61b90e29ba617c8$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var $a61b90e29ba617c8$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $a61b90e29ba617c8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var $a61b90e29ba617c8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a61b90e29ba617c8$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var $a61b90e29ba617c8$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $a61b90e29ba617c8$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var $a61b90e29ba617c8$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $a61b90e29ba617c8$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var $a61b90e29ba617c8$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $a61b90e29ba617c8$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $a61b90e29ba617c8$var$matchOrdinalNumberPattern,
        parsePattern: $a61b90e29ba617c8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $a61b90e29ba617c8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a61b90e29ba617c8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $a61b90e29ba617c8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a61b90e29ba617c8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $a61b90e29ba617c8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a61b90e29ba617c8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $a61b90e29ba617c8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a61b90e29ba617c8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $a61b90e29ba617c8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a61b90e29ba617c8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a61b90e29ba617c8$export$2e2bcd8739ae039 = $a61b90e29ba617c8$var$match;

});


parcelRegister("l5VX8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5b704d2fbc0b05a$export$2e2bcd8739ae039);

var $bNjcX = parcelRequire("bNjcX");

var $7BI96 = parcelRequire("7BI96");

var $jZqjR = parcelRequire("jZqjR");

var $dVGiF = parcelRequire("dVGiF");

var $PeFUd = parcelRequire("PeFUd");
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var $f5b704d2fbc0b05a$var$locale = {
    code: 'sk',
    formatDistance: (0, $bNjcX.default),
    formatLong: (0, $7BI96.default),
    formatRelative: (0, $jZqjR.default),
    localize: (0, $dVGiF.default),
    match: (0, $PeFUd.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $f5b704d2fbc0b05a$export$2e2bcd8739ae039 = $f5b704d2fbc0b05a$var$locale;

});
parcelRegister("bNjcX", function(module, exports) {
$parcel$export(module.exports, "default", () => $89632b9f9f1d792d$export$2e2bcd8739ae039);
function $89632b9f9f1d792d$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $89632b9f9f1d792d$var$declension(scheme, count, time) {
    var group = $89632b9f9f1d792d$var$declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace('{{count}}', String(count));
}
function $89632b9f9f1d792d$var$extractPreposition(token) {
    var result = [
        'lessThan',
        'about',
        'over',
        'almost'
    ].filter(function(preposition) {
        return !!token.match(new RegExp('^' + preposition));
    });
    return result[0];
}
function $89632b9f9f1d792d$var$prefixPreposition(preposition) {
    var translation = '';
    if (preposition === 'almost') translation = 'takmer';
    if (preposition === 'about') translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + ' ' : '';
}
function $89632b9f9f1d792d$var$suffixPreposition(preposition) {
    var translation = '';
    if (preposition === 'lessThan') translation = "menej ne\u017E";
    if (preposition === 'over') translation = "viac ne\u017E";
    return translation.length > 0 ? translation + ' ' : '';
}
function $89632b9f9f1d792d$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $89632b9f9f1d792d$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
        },
        twoFour: {
            present: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
        },
        other: {
            present: "{{count}} sek\xfand",
            past: '{{count}} sekundami',
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
        },
        twoFour: {
            present: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
        },
        other: {
            present: "{{count}} hod\xedn",
            past: '{{count}} hodinami',
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: '{{count}} dni',
            past: "{{count}} d\u0148ami",
            future: '{{count}} dni'
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
        },
        twoFour: {
            present: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
        },
        other: {
            present: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
        }
    },
    xYears: {
        one: {
            present: 'rok',
            past: 'rokom',
            future: 'rok'
        },
        twoFour: {
            present: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
        },
        other: {
            present: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
        }
    }
};
var $89632b9f9f1d792d$var$formatDistance = function formatDistance(token, count, options) {
    var preposition = $89632b9f9f1d792d$var$extractPreposition(token) || '';
    var key = $89632b9f9f1d792d$var$lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = $89632b9f9f1d792d$var$formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $89632b9f9f1d792d$var$prefixPreposition(preposition) + $89632b9f9f1d792d$var$suffixPreposition(preposition) + $89632b9f9f1d792d$var$declension(scheme, count, 'present');
    if (options.comparison && options.comparison > 0) return $89632b9f9f1d792d$var$prefixPreposition(preposition) + 'o ' + $89632b9f9f1d792d$var$suffixPreposition(preposition) + $89632b9f9f1d792d$var$declension(scheme, count, 'future');
    else return $89632b9f9f1d792d$var$prefixPreposition(preposition) + 'pred ' + $89632b9f9f1d792d$var$suffixPreposition(preposition) + $89632b9f9f1d792d$var$declension(scheme, count, 'past');
};
var $89632b9f9f1d792d$export$2e2bcd8739ae039 = $89632b9f9f1d792d$var$formatDistance;

});

parcelRegister("7BI96", function(module, exports) {
$parcel$export(module.exports, "default", () => $589e3b89c822cc65$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $589e3b89c822cc65$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. M. y',
    short: 'd. M. y'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var $589e3b89c822cc65$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var $589e3b89c822cc65$var$dateTimeFormats = {
    full: '{{date}}, {{time}}',
    long: '{{date}}, {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}} {{time}}'
};
var $589e3b89c822cc65$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $589e3b89c822cc65$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $589e3b89c822cc65$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $589e3b89c822cc65$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $589e3b89c822cc65$export$2e2bcd8739ae039 = $589e3b89c822cc65$var$formatLong;

});

parcelRegister("jZqjR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8d82149177ff950$export$2e2bcd8739ae039);

var $2yCTh = parcelRequire("2yCTh");
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var $e8d82149177ff950$var$accusativeWeekdays = [
    "nede\u013Eu",
    'pondelok',
    'utorok',
    'stredu',
    "\u0161tvrtok",
    'piatok',
    'sobotu'
];
function $e8d82149177ff950$var$_lastWeek(day) {
    var weekday = $e8d82149177ff950$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $e8d82149177ff950$var$thisWeek(day) {
    var weekday = $e8d82149177ff950$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $e8d82149177ff950$var$_nextWeek(day) {
    var weekday = $e8d82149177ff950$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var $e8d82149177ff950$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2yCTh.default)(date, baseDate, options)) return $e8d82149177ff950$var$thisWeek(day);
        else return $e8d82149177ff950$var$_lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2yCTh.default)(date, baseDate, options)) return $e8d82149177ff950$var$thisWeek(day);
        else return $e8d82149177ff950$var$_nextWeek(day);
    },
    other: 'P'
};
var $e8d82149177ff950$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $e8d82149177ff950$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $e8d82149177ff950$export$2e2bcd8739ae039 = $e8d82149177ff950$var$formatRelative;

});

parcelRegister("dVGiF", function(module, exports) {
$parcel$export(module.exports, "default", () => $a24169259b281551$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $a24169259b281551$var$eraValues = {
    narrow: [
        'pred Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pred Kr.',
        'po Kr.'
    ],
    wide: [
        'pred Kristom',
        'po Kristovi'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var $a24169259b281551$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var $a24169259b281551$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        'marec',
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'august',
        'september',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $a24169259b281551$var$formattingMonthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        'marca',
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        'augusta',
        'septembra',
        "okt\xf3bra",
        'novembra',
        'decembra'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var $a24169259b281551$var$dayValues = {
    narrow: [
        'n',
        'p',
        'u',
        's',
        "\u0161",
        'p',
        's'
    ],
    short: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    abbreviated: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    wide: [
        "nede\u013Ea",
        'pondelok',
        'utorok',
        'streda',
        "\u0161tvrtok",
        'piatok',
        'sobota'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var $a24169259b281551$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'polnoc',
        noon: 'poludnie',
        morning: "r\xe1no",
        afternoon: 'popoludnie',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $a24169259b281551$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'nap.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'v n.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'napol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'v noci'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o polnoci',
        noon: 'napoludnie',
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: 'v noci'
    }
};
var $a24169259b281551$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $a24169259b281551$var$localize = {
    ordinalNumber: $a24169259b281551$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $a24169259b281551$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $a24169259b281551$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $a24169259b281551$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $a24169259b281551$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $a24169259b281551$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $a24169259b281551$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a24169259b281551$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a24169259b281551$export$2e2bcd8739ae039 = $a24169259b281551$var$localize;

});

parcelRegister("PeFUd", function(module, exports) {
$parcel$export(module.exports, "default", () => $09a025a9fef18962$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $09a025a9fef18962$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $09a025a9fef18962$var$parseOrdinalNumberPattern = /\d+/i;
var $09a025a9fef18962$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var $09a025a9fef18962$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var $09a025a9fef18962$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var $09a025a9fef18962$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $09a025a9fef18962$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var $09a025a9fef18962$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $09a025a9fef18962$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var $09a025a9fef18962$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var $09a025a9fef18962$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var $09a025a9fef18962$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var $09a025a9fef18962$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $09a025a9fef18962$var$matchOrdinalNumberPattern,
        parsePattern: $09a025a9fef18962$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $09a025a9fef18962$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $09a025a9fef18962$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $09a025a9fef18962$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $09a025a9fef18962$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $09a025a9fef18962$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $09a025a9fef18962$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $09a025a9fef18962$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $09a025a9fef18962$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $09a025a9fef18962$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $09a025a9fef18962$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $09a025a9fef18962$export$2e2bcd8739ae039 = $09a025a9fef18962$var$match;

});


parcelRegister("4LoOb", function(module, exports) {
$parcel$export(module.exports, "default", () => $377ecb9e8359500d$export$2e2bcd8739ae039);

var $5P3kG = parcelRequire("5P3kG");

var $73Uvi = parcelRequire("73Uvi");

var $jydVS = parcelRequire("jydVS");

var $6MOUx = parcelRequire("6MOUx");

var $7IEcW = parcelRequire("7IEcW");
/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $377ecb9e8359500d$var$locale = {
    code: 'sv',
    formatDistance: (0, $5P3kG.default),
    formatLong: (0, $73Uvi.default),
    formatRelative: (0, $jydVS.default),
    localize: (0, $6MOUx.default),
    match: (0, $7IEcW.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $377ecb9e8359500d$export$2e2bcd8739ae039 = $377ecb9e8359500d$var$locale;

});
parcelRegister("5P3kG", function(module, exports) {
$parcel$export(module.exports, "default", () => $43d44cf47498cbaf$export$2e2bcd8739ae039);
var $43d44cf47498cbaf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: 'en sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: 'en minut',
        other: '{{count}} minuter'
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: 'en timme',
        other: '{{count}} timmar'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: 'en vecka',
        other: '{{count}} vecka'
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var $43d44cf47498cbaf$var$wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
var $43d44cf47498cbaf$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $43d44cf47498cbaf$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $43d44cf47498cbaf$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
};
var $43d44cf47498cbaf$export$2e2bcd8739ae039 = $43d44cf47498cbaf$var$formatDistance;

});

parcelRegister("73Uvi", function(module, exports) {
$parcel$export(module.exports, "default", () => $5244a4afbc67c410$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $5244a4afbc67c410$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var $5244a4afbc67c410$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $5244a4afbc67c410$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $5244a4afbc67c410$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $5244a4afbc67c410$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $5244a4afbc67c410$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $5244a4afbc67c410$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $5244a4afbc67c410$export$2e2bcd8739ae039 = $5244a4afbc67c410$var$formatLong;

});

parcelRegister("jydVS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3bbfffdf20b2e6d$export$2e2bcd8739ae039);
var $e3bbfffdf20b2e6d$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $e3bbfffdf20b2e6d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e3bbfffdf20b2e6d$var$formatRelativeLocale[token];
};
var $e3bbfffdf20b2e6d$export$2e2bcd8739ae039 = $e3bbfffdf20b2e6d$var$formatRelative;

});

parcelRegister("6MOUx", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f0eb79d6dcfd5ea$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $4f0eb79d6dcfd5ea$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var $4f0eb79d6dcfd5ea$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var $4f0eb79d6dcfd5ea$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $4f0eb79d6dcfd5ea$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $4f0eb79d6dcfd5ea$var$dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var $4f0eb79d6dcfd5ea$var$formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var $4f0eb79d6dcfd5ea$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
};
var $4f0eb79d6dcfd5ea$var$localize = {
    ordinalNumber: $4f0eb79d6dcfd5ea$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $4f0eb79d6dcfd5ea$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $4f0eb79d6dcfd5ea$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $4f0eb79d6dcfd5ea$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $4f0eb79d6dcfd5ea$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $4f0eb79d6dcfd5ea$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4f0eb79d6dcfd5ea$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4f0eb79d6dcfd5ea$export$2e2bcd8739ae039 = $4f0eb79d6dcfd5ea$var$localize;

});

parcelRegister("7IEcW", function(module, exports) {
$parcel$export(module.exports, "default", () => $59ebd4e82ec07ba7$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $59ebd4e82ec07ba7$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $59ebd4e82ec07ba7$var$parseOrdinalNumberPattern = /\d+/i;
var $59ebd4e82ec07ba7$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $59ebd4e82ec07ba7$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $59ebd4e82ec07ba7$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $59ebd4e82ec07ba7$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $59ebd4e82ec07ba7$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $59ebd4e82ec07ba7$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $59ebd4e82ec07ba7$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $59ebd4e82ec07ba7$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $59ebd4e82ec07ba7$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $59ebd4e82ec07ba7$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $59ebd4e82ec07ba7$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $59ebd4e82ec07ba7$var$matchOrdinalNumberPattern,
        parsePattern: $59ebd4e82ec07ba7$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $59ebd4e82ec07ba7$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $59ebd4e82ec07ba7$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $59ebd4e82ec07ba7$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $59ebd4e82ec07ba7$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $59ebd4e82ec07ba7$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $59ebd4e82ec07ba7$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $59ebd4e82ec07ba7$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $59ebd4e82ec07ba7$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $59ebd4e82ec07ba7$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $59ebd4e82ec07ba7$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $59ebd4e82ec07ba7$export$2e2bcd8739ae039 = $59ebd4e82ec07ba7$var$match;

});


parcelRegister("14vzk", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c7ea70ec746ede2$export$2e2bcd8739ae039);

var $gtx34 = parcelRequire("gtx34");

var $aQzHP = parcelRequire("aQzHP");

var $8r09W = parcelRequire("8r09W");

var $2yMOC = parcelRequire("2yMOC");

var $9SQJ7 = parcelRequire("9SQJ7");
/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var $0c7ea70ec746ede2$var$locale = {
    code: 'tr',
    formatDistance: (0, $gtx34.default),
    formatLong: (0, $aQzHP.default),
    formatRelative: (0, $8r09W.default),
    localize: (0, $2yMOC.default),
    match: (0, $9SQJ7.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $0c7ea70ec746ede2$export$2e2bcd8739ae039 = $0c7ea70ec746ede2$var$locale;

});
parcelRegister("gtx34", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfe8fd83eadbfb61$export$2e2bcd8739ae039);
var $bfe8fd83eadbfb61$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'bir saniyeden az',
        other: '{{count}} saniyeden az'
    },
    xSeconds: {
        one: '1 saniye',
        other: '{{count}} saniye'
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: 'bir dakikadan az',
        other: '{{count}} dakikadan az'
    },
    xMinutes: {
        one: '1 dakika',
        other: '{{count}} dakika'
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
var $bfe8fd83eadbfb61$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bfe8fd83eadbfb61$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \xf6nce";
    }
    return result;
};
var $bfe8fd83eadbfb61$export$2e2bcd8739ae039 = $bfe8fd83eadbfb61$var$formatDistance;

});

parcelRegister("aQzHP", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e5a752643ba139e$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $7e5a752643ba139e$var$dateFormats = {
    full: 'd MMMM y EEEE',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.yyyy'
};
var $7e5a752643ba139e$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7e5a752643ba139e$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $7e5a752643ba139e$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $7e5a752643ba139e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $7e5a752643ba139e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $7e5a752643ba139e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7e5a752643ba139e$export$2e2bcd8739ae039 = $7e5a752643ba139e$var$formatLong;

});

parcelRegister("8r09W", function(module, exports) {
$parcel$export(module.exports, "default", () => $6240f7f7a398b6e6$export$2e2bcd8739ae039);
var $6240f7f7a398b6e6$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: 'P'
};
var $6240f7f7a398b6e6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6240f7f7a398b6e6$var$formatRelativeLocale[token];
};
var $6240f7f7a398b6e6$export$2e2bcd8739ae039 = $6240f7f7a398b6e6$var$formatRelative;

});

parcelRegister("2yMOC", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dd49f74f71c5ad1$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $1dd49f74f71c5ad1$var$eraValues = {
    narrow: [
        "M\xd6",
        'MS'
    ],
    abbreviated: [
        "M\xd6",
        'MS'
    ],
    wide: [
        "Milattan \xd6nce",
        'Milattan Sonra'
    ]
};
var $1dd49f74f71c5ad1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var $1dd49f74f71c5ad1$var$monthValues = {
    narrow: [
        'O',
        "\u015E",
        'M',
        'N',
        'M',
        'H',
        'T',
        'A',
        'E',
        'E',
        'K',
        'A'
    ],
    abbreviated: [
        'Oca',
        "\u015Eub",
        'Mar',
        'Nis',
        'May',
        'Haz',
        'Tem',
        "A\u011Fu",
        'Eyl',
        'Eki',
        'Kas',
        'Ara'
    ],
    wide: [
        'Ocak',
        "\u015Eubat",
        'Mart',
        'Nisan',
        "May\u0131s",
        'Haziran',
        'Temmuz',
        "A\u011Fustos",
        "Eyl\xfcl",
        'Ekim',
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var $1dd49f74f71c5ad1$var$dayValues = {
    narrow: [
        'P',
        'P',
        'S',
        "\xc7",
        'P',
        'C',
        'C'
    ],
    short: [
        'Pz',
        'Pt',
        'Sa',
        "\xc7a",
        'Pe',
        'Cu',
        'Ct'
    ],
    abbreviated: [
        'Paz',
        'Pzt',
        'Sal',
        "\xc7ar",
        'Per',
        'Cum',
        'Cts'
    ],
    wide: [
        'Pazar',
        'Pazartesi',
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        'Cuma',
        'Cumartesi'
    ]
};
var $1dd49f74f71c5ad1$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    }
};
var $1dd49f74f71c5ad1$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    }
};
var $1dd49f74f71c5ad1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $1dd49f74f71c5ad1$var$localize = {
    ordinalNumber: $1dd49f74f71c5ad1$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $1dd49f74f71c5ad1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $1dd49f74f71c5ad1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $1dd49f74f71c5ad1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $1dd49f74f71c5ad1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $1dd49f74f71c5ad1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1dd49f74f71c5ad1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1dd49f74f71c5ad1$export$2e2bcd8739ae039 = $1dd49f74f71c5ad1$var$localize;

});

parcelRegister("9SQJ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $73220e9f636d05b1$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $73220e9f636d05b1$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $73220e9f636d05b1$var$parseOrdinalNumberPattern = /\d+/i;
var $73220e9f636d05b1$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var $73220e9f636d05b1$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var $73220e9f636d05b1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var $73220e9f636d05b1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var $73220e9f636d05b1$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var $73220e9f636d05b1$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var $73220e9f636d05b1$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var $73220e9f636d05b1$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var $73220e9f636d05b1$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var $73220e9f636d05b1$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var $73220e9f636d05b1$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $73220e9f636d05b1$var$matchOrdinalNumberPattern,
        parsePattern: $73220e9f636d05b1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $73220e9f636d05b1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $73220e9f636d05b1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $73220e9f636d05b1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $73220e9f636d05b1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $73220e9f636d05b1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $73220e9f636d05b1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $73220e9f636d05b1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $73220e9f636d05b1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $73220e9f636d05b1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $73220e9f636d05b1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $73220e9f636d05b1$export$2e2bcd8739ae039 = $73220e9f636d05b1$var$match;

});


parcelRegister("imuCA", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5e208db9208727f$export$2e2bcd8739ae039);

var $eKMDg = parcelRequire("eKMDg");

var $eE9Og = parcelRequire("eE9Og");

var $4abea = parcelRequire("4abea");

var $70K42 = parcelRequire("70K42");

var $Slpoe = parcelRequire("Slpoe");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $d5e208db9208727f$var$locale = {
    code: 'zh-CN',
    formatDistance: (0, $eKMDg.default),
    formatLong: (0, $eE9Og.default),
    formatRelative: (0, $4abea.default),
    localize: (0, $70K42.default),
    match: (0, $Slpoe.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d5e208db9208727f$export$2e2bcd8739ae039 = $d5e208db9208727f$var$locale;

});
parcelRegister("eKMDg", function(module, exports) {
$parcel$export(module.exports, "default", () => $abdb15f02afc2fff$export$2e2bcd8739ae039);
var $abdb15f02afc2fff$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
var $abdb15f02afc2fff$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $abdb15f02afc2fff$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
var $abdb15f02afc2fff$export$2e2bcd8739ae039 = $abdb15f02afc2fff$var$formatDistance;

});

parcelRegister("eE9Og", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa9c6918839481d1$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $aa9c6918839481d1$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $aa9c6918839481d1$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $aa9c6918839481d1$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $aa9c6918839481d1$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $aa9c6918839481d1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $aa9c6918839481d1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $aa9c6918839481d1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $aa9c6918839481d1$export$2e2bcd8739ae039 = $aa9c6918839481d1$var$formatLong;

});

parcelRegister("4abea", function(module, exports) {
$parcel$export(module.exports, "default", () => $3080ce24cf89f859$export$2e2bcd8739ae039);

var $2yCTh = parcelRequire("2yCTh");
function $3080ce24cf89f859$var$checkWeek(date, baseDate, options) {
    var baseFormat = 'eeee p';
    if ((0, $2yCTh.default)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var $3080ce24cf89f859$var$formatRelativeLocale = {
    lastWeek: $3080ce24cf89f859$var$checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $3080ce24cf89f859$var$checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: 'PP p'
};
var $3080ce24cf89f859$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $3080ce24cf89f859$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $3080ce24cf89f859$export$2e2bcd8739ae039 = $3080ce24cf89f859$var$formatRelative;

});

parcelRegister("70K42", function(module, exports) {
$parcel$export(module.exports, "default", () => $51ac43d8c208ec1d$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $51ac43d8c208ec1d$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $51ac43d8c208ec1d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $51ac43d8c208ec1d$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $51ac43d8c208ec1d$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $51ac43d8c208ec1d$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $51ac43d8c208ec1d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $51ac43d8c208ec1d$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u65F6";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
var $51ac43d8c208ec1d$var$localize = {
    ordinalNumber: $51ac43d8c208ec1d$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $51ac43d8c208ec1d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $51ac43d8c208ec1d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $51ac43d8c208ec1d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $51ac43d8c208ec1d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $51ac43d8c208ec1d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $51ac43d8c208ec1d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $51ac43d8c208ec1d$export$2e2bcd8739ae039 = $51ac43d8c208ec1d$var$localize;

});

parcelRegister("Slpoe", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a35a68b7a71af71$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $0a35a68b7a71af71$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var $0a35a68b7a71af71$var$parseOrdinalNumberPattern = /\d+/i;
var $0a35a68b7a71af71$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $0a35a68b7a71af71$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $0a35a68b7a71af71$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var $0a35a68b7a71af71$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $0a35a68b7a71af71$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $0a35a68b7a71af71$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $0a35a68b7a71af71$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $0a35a68b7a71af71$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $0a35a68b7a71af71$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var $0a35a68b7a71af71$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $0a35a68b7a71af71$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $0a35a68b7a71af71$var$matchOrdinalNumberPattern,
        parsePattern: $0a35a68b7a71af71$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $0a35a68b7a71af71$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a35a68b7a71af71$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $0a35a68b7a71af71$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a35a68b7a71af71$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $0a35a68b7a71af71$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a35a68b7a71af71$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $0a35a68b7a71af71$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a35a68b7a71af71$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $0a35a68b7a71af71$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0a35a68b7a71af71$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0a35a68b7a71af71$export$2e2bcd8739ae039 = $0a35a68b7a71af71$var$match;

});


parcelRegister("87cPi", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e88ed355475a109$export$2e2bcd8739ae039);

var $4r1KJ = parcelRequire("4r1KJ");

var $cQZkC = parcelRequire("cQZkC");

var $15KuN = parcelRequire("15KuN");

var $5KNwx = parcelRequire("5KNwx");

var $dgnx7 = parcelRequire("dgnx7");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $5e88ed355475a109$var$locale = {
    code: 'zh-TW',
    formatDistance: (0, $4r1KJ.default),
    formatLong: (0, $cQZkC.default),
    formatRelative: (0, $15KuN.default),
    localize: (0, $5KNwx.default),
    match: (0, $dgnx7.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5e88ed355475a109$export$2e2bcd8739ae039 = $5e88ed355475a109$var$locale;

});
parcelRegister("4r1KJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $33ab0b16461e8639$export$2e2bcd8739ae039);
var $33ab0b16461e8639$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $33ab0b16461e8639$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $33ab0b16461e8639$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $33ab0b16461e8639$export$2e2bcd8739ae039 = $33ab0b16461e8639$var$formatDistance;

});

parcelRegister("cQZkC", function(module, exports) {
$parcel$export(module.exports, "default", () => $95b9ea85a75396e7$export$2e2bcd8739ae039);

var $3lv7c = parcelRequire("3lv7c");
var $95b9ea85a75396e7$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $95b9ea85a75396e7$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $95b9ea85a75396e7$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $95b9ea85a75396e7$var$formatLong = {
    date: (0, $3lv7c.default)({
        formats: $95b9ea85a75396e7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $3lv7c.default)({
        formats: $95b9ea85a75396e7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $3lv7c.default)({
        formats: $95b9ea85a75396e7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $95b9ea85a75396e7$export$2e2bcd8739ae039 = $95b9ea85a75396e7$var$formatLong;

});

parcelRegister("15KuN", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cba5321ad20004e$export$2e2bcd8739ae039);
var $0cba5321ad20004e$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var $0cba5321ad20004e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0cba5321ad20004e$var$formatRelativeLocale[token];
};
var $0cba5321ad20004e$export$2e2bcd8739ae039 = $0cba5321ad20004e$var$formatRelative;

});

parcelRegister("5KNwx", function(module, exports) {
$parcel$export(module.exports, "default", () => $4307aa04d810d3d1$export$2e2bcd8739ae039);

var $nOHjC = parcelRequire("nOHjC");
var $4307aa04d810d3d1$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $4307aa04d810d3d1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var $4307aa04d810d3d1$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $4307aa04d810d3d1$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $4307aa04d810d3d1$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $4307aa04d810d3d1$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $4307aa04d810d3d1$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $4307aa04d810d3d1$var$localize = {
    ordinalNumber: $4307aa04d810d3d1$var$ordinalNumber,
    era: (0, $nOHjC.default)({
        values: $4307aa04d810d3d1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $nOHjC.default)({
        values: $4307aa04d810d3d1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $nOHjC.default)({
        values: $4307aa04d810d3d1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $nOHjC.default)({
        values: $4307aa04d810d3d1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $nOHjC.default)({
        values: $4307aa04d810d3d1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4307aa04d810d3d1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4307aa04d810d3d1$export$2e2bcd8739ae039 = $4307aa04d810d3d1$var$localize;

});

parcelRegister("dgnx7", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a7f06325ed9988b$export$2e2bcd8739ae039);

var $5CeaO = parcelRequire("5CeaO");

var $ifMvQ = parcelRequire("ifMvQ");
var $9a7f06325ed9988b$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $9a7f06325ed9988b$var$parseOrdinalNumberPattern = /\d+/i;
var $9a7f06325ed9988b$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $9a7f06325ed9988b$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $9a7f06325ed9988b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var $9a7f06325ed9988b$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $9a7f06325ed9988b$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $9a7f06325ed9988b$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $9a7f06325ed9988b$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $9a7f06325ed9988b$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $9a7f06325ed9988b$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $9a7f06325ed9988b$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $9a7f06325ed9988b$var$match = {
    ordinalNumber: (0, $ifMvQ.default)({
        matchPattern: $9a7f06325ed9988b$var$matchOrdinalNumberPattern,
        parsePattern: $9a7f06325ed9988b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5CeaO.default)({
        matchPatterns: $9a7f06325ed9988b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9a7f06325ed9988b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5CeaO.default)({
        matchPatterns: $9a7f06325ed9988b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9a7f06325ed9988b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $5CeaO.default)({
        matchPatterns: $9a7f06325ed9988b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9a7f06325ed9988b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5CeaO.default)({
        matchPatterns: $9a7f06325ed9988b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9a7f06325ed9988b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5CeaO.default)({
        matchPatterns: $9a7f06325ed9988b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $9a7f06325ed9988b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $9a7f06325ed9988b$export$2e2bcd8739ae039 = $9a7f06325ed9988b$var$match;

});


parcelRegister("8PbTf", function(module, exports) {

var $lIkJm = parcelRequire("lIkJm");
/** Used to compose bitmasks for cloning. */ var $66cc4f4d06ff5384$var$CLONE_DEEP_FLAG = 1, $66cc4f4d06ff5384$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $66cc4f4d06ff5384$var$cloneDeep(value) {
    return $lIkJm(value, $66cc4f4d06ff5384$var$CLONE_DEEP_FLAG | $66cc4f4d06ff5384$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $66cc4f4d06ff5384$var$cloneDeep;

});
parcelRegister("lIkJm", function(module, exports) {

var $1o5lC = parcelRequire("1o5lC");

var $lGcQ6 = parcelRequire("lGcQ6");

var $5is2l = parcelRequire("5is2l");

var $bz9it = parcelRequire("bz9it");

var $FQtFa = parcelRequire("FQtFa");

var $9FGhO = parcelRequire("9FGhO");

var $1HGns = parcelRequire("1HGns");

var $6xRHL = parcelRequire("6xRHL");

var $6zy2C = parcelRequire("6zy2C");

var $eZrL0 = parcelRequire("eZrL0");

var $h6JwX = parcelRequire("h6JwX");

var $fulLp = parcelRequire("fulLp");

var $dWuiq = parcelRequire("dWuiq");

var $8ZWdP = parcelRequire("8ZWdP");

var $179ZK = parcelRequire("179ZK");

var $3ueRr = parcelRequire("3ueRr");

var $hq6sV = parcelRequire("hq6sV");

var $9uQ7P = parcelRequire("9uQ7P");

var $04RAq = parcelRequire("04RAq");

var $kWZtp = parcelRequire("kWZtp");

var $jIoBN = parcelRequire("jIoBN");

var $40Z2D = parcelRequire("40Z2D");
/** Used to compose bitmasks for cloning. */ var $fcedc9b5429f144b$var$CLONE_DEEP_FLAG = 1, $fcedc9b5429f144b$var$CLONE_FLAT_FLAG = 2, $fcedc9b5429f144b$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $fcedc9b5429f144b$var$argsTag = '[object Arguments]', $fcedc9b5429f144b$var$arrayTag = '[object Array]', $fcedc9b5429f144b$var$boolTag = '[object Boolean]', $fcedc9b5429f144b$var$dateTag = '[object Date]', $fcedc9b5429f144b$var$errorTag = '[object Error]', $fcedc9b5429f144b$var$funcTag = '[object Function]', $fcedc9b5429f144b$var$genTag = '[object GeneratorFunction]', $fcedc9b5429f144b$var$mapTag = '[object Map]', $fcedc9b5429f144b$var$numberTag = '[object Number]', $fcedc9b5429f144b$var$objectTag = '[object Object]', $fcedc9b5429f144b$var$regexpTag = '[object RegExp]', $fcedc9b5429f144b$var$setTag = '[object Set]', $fcedc9b5429f144b$var$stringTag = '[object String]', $fcedc9b5429f144b$var$symbolTag = '[object Symbol]', $fcedc9b5429f144b$var$weakMapTag = '[object WeakMap]';
var $fcedc9b5429f144b$var$arrayBufferTag = '[object ArrayBuffer]', $fcedc9b5429f144b$var$dataViewTag = '[object DataView]', $fcedc9b5429f144b$var$float32Tag = '[object Float32Array]', $fcedc9b5429f144b$var$float64Tag = '[object Float64Array]', $fcedc9b5429f144b$var$int8Tag = '[object Int8Array]', $fcedc9b5429f144b$var$int16Tag = '[object Int16Array]', $fcedc9b5429f144b$var$int32Tag = '[object Int32Array]', $fcedc9b5429f144b$var$uint8Tag = '[object Uint8Array]', $fcedc9b5429f144b$var$uint8ClampedTag = '[object Uint8ClampedArray]', $fcedc9b5429f144b$var$uint16Tag = '[object Uint16Array]', $fcedc9b5429f144b$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $fcedc9b5429f144b$var$cloneableTags = {};
$fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$argsTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$arrayTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$arrayBufferTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$dataViewTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$boolTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$dateTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$float32Tag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$float64Tag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$int8Tag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$int16Tag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$int32Tag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$mapTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$numberTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$objectTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$regexpTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$setTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$stringTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$symbolTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$uint8Tag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$uint8ClampedTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$uint16Tag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$uint32Tag] = true;
$fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$errorTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$funcTag] = $fcedc9b5429f144b$var$cloneableTags[$fcedc9b5429f144b$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $fcedc9b5429f144b$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $fcedc9b5429f144b$var$CLONE_DEEP_FLAG, isFlat = bitmask & $fcedc9b5429f144b$var$CLONE_FLAT_FLAG, isFull = bitmask & $fcedc9b5429f144b$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$04RAq(value)) return value;
    var isArr = $3ueRr(value);
    if (isArr) {
        result = $dWuiq(value);
        if (!isDeep) return $1HGns(value, result);
    } else {
        var tag = $fulLp(value), isFunc = tag == $fcedc9b5429f144b$var$funcTag || tag == $fcedc9b5429f144b$var$genTag;
        if ($hq6sV(value)) return $9FGhO(value, isDeep);
        if (tag == $fcedc9b5429f144b$var$objectTag || tag == $fcedc9b5429f144b$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $179ZK(value);
            if (!isDeep) return isFlat ? $6zy2C(value, $FQtFa(result, value)) : $6xRHL(value, $bz9it(result, value));
        } else {
            if (!$fcedc9b5429f144b$var$cloneableTags[tag]) return object ? value : {};
            result = $8ZWdP(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $1o5lC);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($kWZtp(value)) value.forEach(function(subValue) {
        result.add($fcedc9b5429f144b$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($9uQ7P(value)) value.forEach(function(subValue, key) {
        result.set(key, $fcedc9b5429f144b$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $h6JwX : $eZrL0 : isFlat ? $40Z2D : $jIoBN;
    var props = isArr ? undefined : keysFunc(value);
    $lGcQ6(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $5is2l(result, key, $fcedc9b5429f144b$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $fcedc9b5429f144b$var$baseClone;

});
parcelRegister("lGcQ6", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $fc877adeb5c27935$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $fc877adeb5c27935$var$arrayEach;

});

parcelRegister("bz9it", function(module, exports) {

var $5r40O = parcelRequire("5r40O");

var $jIoBN = parcelRequire("jIoBN");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $86ba2ccc5363668f$var$baseAssign(object, source) {
    return object && $5r40O(source, $jIoBN(source), object);
}
module.exports = $86ba2ccc5363668f$var$baseAssign;

});

parcelRegister("FQtFa", function(module, exports) {

var $5r40O = parcelRequire("5r40O");

var $40Z2D = parcelRequire("40Z2D");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $07dc896014dce9d1$var$baseAssignIn(object, source) {
    return object && $5r40O(source, $40Z2D(source), object);
}
module.exports = $07dc896014dce9d1$var$baseAssignIn;

});

parcelRegister("6xRHL", function(module, exports) {

var $5r40O = parcelRequire("5r40O");

var $bD38s = parcelRequire("bD38s");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $4c3f7bc9a05c365c$var$copySymbols(source, object) {
    return $5r40O(source, $bD38s(source), object);
}
module.exports = $4c3f7bc9a05c365c$var$copySymbols;

});

parcelRegister("6zy2C", function(module, exports) {

var $5r40O = parcelRequire("5r40O");

var $kyvXc = parcelRequire("kyvXc");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $4c906adc720d6d8f$var$copySymbolsIn(source, object) {
    return $5r40O(source, $kyvXc(source), object);
}
module.exports = $4c906adc720d6d8f$var$copySymbolsIn;

});

parcelRegister("dWuiq", function(module, exports) {
/** Used for built-in method references. */ var $a2683152631dfe7c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a2683152631dfe7c$var$hasOwnProperty = $a2683152631dfe7c$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $a2683152631dfe7c$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $a2683152631dfe7c$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $a2683152631dfe7c$var$initCloneArray;

});

parcelRegister("8ZWdP", function(module, exports) {

var $lNRts = parcelRequire("lNRts");

var $inq08 = parcelRequire("inq08");

var $5MddS = parcelRequire("5MddS");

var $3z7AJ = parcelRequire("3z7AJ");

var $l22HV = parcelRequire("l22HV");
/** `Object#toString` result references. */ var $68d12eed71e29e27$var$boolTag = '[object Boolean]', $68d12eed71e29e27$var$dateTag = '[object Date]', $68d12eed71e29e27$var$mapTag = '[object Map]', $68d12eed71e29e27$var$numberTag = '[object Number]', $68d12eed71e29e27$var$regexpTag = '[object RegExp]', $68d12eed71e29e27$var$setTag = '[object Set]', $68d12eed71e29e27$var$stringTag = '[object String]', $68d12eed71e29e27$var$symbolTag = '[object Symbol]';
var $68d12eed71e29e27$var$arrayBufferTag = '[object ArrayBuffer]', $68d12eed71e29e27$var$dataViewTag = '[object DataView]', $68d12eed71e29e27$var$float32Tag = '[object Float32Array]', $68d12eed71e29e27$var$float64Tag = '[object Float64Array]', $68d12eed71e29e27$var$int8Tag = '[object Int8Array]', $68d12eed71e29e27$var$int16Tag = '[object Int16Array]', $68d12eed71e29e27$var$int32Tag = '[object Int32Array]', $68d12eed71e29e27$var$uint8Tag = '[object Uint8Array]', $68d12eed71e29e27$var$uint8ClampedTag = '[object Uint8ClampedArray]', $68d12eed71e29e27$var$uint16Tag = '[object Uint16Array]', $68d12eed71e29e27$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $68d12eed71e29e27$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $68d12eed71e29e27$var$arrayBufferTag:
            return $lNRts(object);
        case $68d12eed71e29e27$var$boolTag:
        case $68d12eed71e29e27$var$dateTag:
            return new Ctor(+object);
        case $68d12eed71e29e27$var$dataViewTag:
            return $inq08(object, isDeep);
        case $68d12eed71e29e27$var$float32Tag:
        case $68d12eed71e29e27$var$float64Tag:
        case $68d12eed71e29e27$var$int8Tag:
        case $68d12eed71e29e27$var$int16Tag:
        case $68d12eed71e29e27$var$int32Tag:
        case $68d12eed71e29e27$var$uint8Tag:
        case $68d12eed71e29e27$var$uint8ClampedTag:
        case $68d12eed71e29e27$var$uint16Tag:
        case $68d12eed71e29e27$var$uint32Tag:
            return $l22HV(object, isDeep);
        case $68d12eed71e29e27$var$mapTag:
            return new Ctor;
        case $68d12eed71e29e27$var$numberTag:
        case $68d12eed71e29e27$var$stringTag:
            return new Ctor(object);
        case $68d12eed71e29e27$var$regexpTag:
            return $5MddS(object);
        case $68d12eed71e29e27$var$setTag:
            return new Ctor;
        case $68d12eed71e29e27$var$symbolTag:
            return $3z7AJ(object);
    }
}
module.exports = $68d12eed71e29e27$var$initCloneByTag;

});
parcelRegister("inq08", function(module, exports) {

var $lNRts = parcelRequire("lNRts");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $d60e8b484574aebd$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $lNRts(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $d60e8b484574aebd$var$cloneDataView;

});

parcelRegister("5MddS", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $434bb135bcaffc44$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $434bb135bcaffc44$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $434bb135bcaffc44$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $434bb135bcaffc44$var$cloneRegExp;

});

parcelRegister("3z7AJ", function(module, exports) {

var $i2SUR = parcelRequire("i2SUR");
/** Used to convert symbols to primitives and strings. */ var $298a8776d8f64e41$var$symbolProto = $i2SUR ? $i2SUR.prototype : undefined, $298a8776d8f64e41$var$symbolValueOf = $298a8776d8f64e41$var$symbolProto ? $298a8776d8f64e41$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $298a8776d8f64e41$var$cloneSymbol(symbol) {
    return $298a8776d8f64e41$var$symbolValueOf ? Object($298a8776d8f64e41$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $298a8776d8f64e41$var$cloneSymbol;

});


parcelRegister("9uQ7P", function(module, exports) {

var $9xRK6 = parcelRequire("9xRK6");

var $lOpW6 = parcelRequire("lOpW6");

var $c9k02 = parcelRequire("c9k02");
/* Node.js helper references. */ var $6e9f595ea18732b5$var$nodeIsMap = $c9k02 && $c9k02.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $6e9f595ea18732b5$var$isMap = $6e9f595ea18732b5$var$nodeIsMap ? $lOpW6($6e9f595ea18732b5$var$nodeIsMap) : $9xRK6;
module.exports = $6e9f595ea18732b5$var$isMap;

});
parcelRegister("9xRK6", function(module, exports) {

var $fulLp = parcelRequire("fulLp");

var $5kXE7 = parcelRequire("5kXE7");
/** `Object#toString` result references. */ var $6f30e24519fe3083$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $6f30e24519fe3083$var$baseIsMap(value) {
    return $5kXE7(value) && $fulLp(value) == $6f30e24519fe3083$var$mapTag;
}
module.exports = $6f30e24519fe3083$var$baseIsMap;

});


parcelRegister("kWZtp", function(module, exports) {

var $9KbFF = parcelRequire("9KbFF");

var $lOpW6 = parcelRequire("lOpW6");

var $c9k02 = parcelRequire("c9k02");
/* Node.js helper references. */ var $f408e8c60f0827bd$var$nodeIsSet = $c9k02 && $c9k02.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $f408e8c60f0827bd$var$isSet = $f408e8c60f0827bd$var$nodeIsSet ? $lOpW6($f408e8c60f0827bd$var$nodeIsSet) : $9KbFF;
module.exports = $f408e8c60f0827bd$var$isSet;

});
parcelRegister("9KbFF", function(module, exports) {

var $fulLp = parcelRequire("fulLp");

var $5kXE7 = parcelRequire("5kXE7");
/** `Object#toString` result references. */ var $718176949d66301a$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $718176949d66301a$var$baseIsSet(value) {
    return $5kXE7(value) && $fulLp(value) == $718176949d66301a$var$setTag;
}
module.exports = $718176949d66301a$var$baseIsSet;

});




parcelRegister("28vg4", function(module, exports) {
$parcel$export(module.exports, "getUserTiming", () => $18e4935c8ddc3b0c$export$4660d4a735328f2a);
var $18e4935c8ddc3b0c$var$n = "undefined" != typeof window ? window.performance : null;
function $18e4935c8ddc3b0c$export$a2a699fa5b2b1ed4(n) {
    void 0 === n && (n = {});
    var t = {
        deviceType: $18e4935c8ddc3b0c$export$abfb0136cf8e916b(),
        effectiveConnectionType: $18e4935c8ddc3b0c$export$265dfeca3f5017b9(),
        timeToFirstByte: $18e4935c8ddc3b0c$export$9a2904da0506c3ba(),
        firstPaint: $18e4935c8ddc3b0c$export$819e7a0b13f5961(),
        firstContentfulPaint: $18e4935c8ddc3b0c$export$3086fa1a9fb7f683(),
        domContentLoaded: $18e4935c8ddc3b0c$export$d6856d1fab905de0(),
        onLoad: $18e4935c8ddc3b0c$export$7259a7b98f0280a3()
    };
    return t.onLoad ? ((n.url || n.all) && (t.url = $18e4935c8ddc3b0c$export$94df0e59ebebf4a7()), (n.userAgent || n.all) && (t.userAgent = $18e4935c8ddc3b0c$export$7935961ef7719cb0()), (n.deviceMemory || n.all) && (t.deviceMemory = $18e4935c8ddc3b0c$export$bf34885f68c1d5e5()), (n.userTiming || n.all) && (t.userTiming = $18e4935c8ddc3b0c$export$4660d4a735328f2a()), (n.longTasks || n.all) && (t.longTasks = $18e4935c8ddc3b0c$export$a08a64ac61b1ac4e()), (n.resources || n.all) && (t.resources = $18e4935c8ddc3b0c$export$a0d4d2a74c7df9f()), Promise.resolve(t)) : new Promise(function(n) {
        return setTimeout(n, 250);
    }).then(function() {
        return $18e4935c8ddc3b0c$export$a2a699fa5b2b1ed4(n);
    });
}
function $18e4935c8ddc3b0c$export$bf7f2fce5c1cf636(e) {
    $18e4935c8ddc3b0c$var$n && $18e4935c8ddc3b0c$var$n.mark && $18e4935c8ddc3b0c$var$n.mark(e);
}
function $18e4935c8ddc3b0c$export$83602b44513dc228(e, t) {
    if ($18e4935c8ddc3b0c$var$n && $18e4935c8ddc3b0c$var$n.measure) try {
        $18e4935c8ddc3b0c$var$n.measure(e, t);
    } catch (n) {
        console.error(n);
    }
}
function $18e4935c8ddc3b0c$export$265dfeca3f5017b9() {
    var n = "undefined" != typeof navigator ? navigator.connection || navigator.mozConnection || navigator.webkitConnection : null;
    return n ? n.effectiveType : null;
}
function $18e4935c8ddc3b0c$export$819e7a0b13f5961() {
    if (!$18e4935c8ddc3b0c$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $18e4935c8ddc3b0c$var$n.getEntriesByType("paint").find(function(n) {
        return "first-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $18e4935c8ddc3b0c$export$3086fa1a9fb7f683() {
    if (!$18e4935c8ddc3b0c$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $18e4935c8ddc3b0c$var$n.getEntriesByType("paint").find(function(n) {
        return "first-contentful-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $18e4935c8ddc3b0c$export$9a2904da0506c3ba() {
    if (!$18e4935c8ddc3b0c$var$n) return null;
    var e = $18e4935c8ddc3b0c$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].responseStart) : null;
}
function $18e4935c8ddc3b0c$export$d6856d1fab905de0() {
    if (!$18e4935c8ddc3b0c$var$n) return null;
    var e = $18e4935c8ddc3b0c$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].domContentLoadedEventEnd) : null;
}
function $18e4935c8ddc3b0c$export$7259a7b98f0280a3() {
    if (!$18e4935c8ddc3b0c$var$n) return null;
    var e = $18e4935c8ddc3b0c$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].loadEventEnd) : null;
}
function $18e4935c8ddc3b0c$export$abfb0136cf8e916b(n) {
    void 0 === n && (n = $18e4935c8ddc3b0c$export$7935961ef7719cb0()), n = n.toLowerCase();
    var e = function(e) {
        return -1 !== n.indexOf(e);
    }, t = e("windows"), r = t && e("phone"), i = t && e("touch") && !r, o = !t && e("iphone"), a = e("ipod"), u = e("ipad"), d = !t && e("android"), l = d && e("mobile"), f = d && !e("mobile");
    return l || o || a || r ? "phone" : u || f || i ? "tablet" : "desktop";
}
function $18e4935c8ddc3b0c$export$94df0e59ebebf4a7() {
    return window.location.href;
}
function $18e4935c8ddc3b0c$export$7935961ef7719cb0() {
    return window.navigator.userAgent;
}
function $18e4935c8ddc3b0c$export$bf34885f68c1d5e5() {
    var n = "undefined" != typeof navigator ? navigator.deviceMemory : void 0;
    return void 0 === n ? null : n > 1 ? "full" : "lite";
}
function $18e4935c8ddc3b0c$export$4660d4a735328f2a() {
    if (!$18e4935c8ddc3b0c$var$n || "undefined" == typeof PerformanceMark) return null;
    var e = $18e4935c8ddc3b0c$var$n.getEntriesByType("mark").map(function(n) {
        return {
            type: "mark",
            name: n.name,
            startTime: Math.round(n.startTime)
        };
    }), t = $18e4935c8ddc3b0c$var$n.getEntriesByType("measure").map(function(n) {
        return {
            type: "measure",
            name: n.name,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
    return e.concat(t);
}
function $18e4935c8ddc3b0c$export$a0d4d2a74c7df9f() {
    return $18e4935c8ddc3b0c$var$n && "undefined" != typeof PerformanceResourceTiming ? $18e4935c8ddc3b0c$var$n.getEntriesByType("navigation").concat($18e4935c8ddc3b0c$var$n.getEntriesByType("resource")).map(function(n) {
        return {
            url: n.name,
            type: n.initiatorType,
            size: n.transferSize,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    }) : null;
}
function $18e4935c8ddc3b0c$export$a08a64ac61b1ac4e() {
    return void 0 === window.__lt ? null : window.__lt.e.map(function(n) {
        return {
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
}

});

const $32f4f7c20d37fe6f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $32f4f7c20d37fe6f$export$f005e2e9f707cb5f = 'commercial';
const $32f4f7c20d37fe6f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $32f4f7c20d37fe6f$export$a739cd5aac835909 = 'stg';
const $32f4f7c20d37fe6f$export$42dd0cdd351a4a9 = 'prod';
const $32f4f7c20d37fe6f$export$404582bc18fe4d9e = 'dev';

const $454bc9fe95ddf677$export$42f4885608027d0c = 'non_boolean';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

const $8fdfc4bb9d992697$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $8fdfc4bb9d992697$export$f005e2e9f707cb5f = 'commercial';
const $8fdfc4bb9d992697$export$17b81a3d6c98013c = 'isolated-cloud';
const $8fdfc4bb9d992697$export$a739cd5aac835909 = 'staging';
const $8fdfc4bb9d992697$export$42dd0cdd351a4a9 = 'prod';
const $8fdfc4bb9d992697$export$404582bc18fe4d9e = 'dev';
const $8fdfc4bb9d992697$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $8fdfc4bb9d992697$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $8fdfc4bb9d992697$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $8fdfc4bb9d992697$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $8fdfc4bb9d992697$export$b61e047ddcc35726 = 'GCP';
const $8fdfc4bb9d992697$export$1baf17f3e645a2b2 = 'AWS';

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $e4ed38fc0d2bdea8$export$a4ad2735b021c132 = '1.9.1';

const $a858cae85500b1b2$export$cf090d5281b5ae06 = 10000;
const $a858cae85500b1b2$export$8575e30be0feb909 = 30000;

const $f262fb6c2e32d015$export$d8b468db8a225bc9 = 250;

const $42033962320073ac$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $42033962320073ac$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $42033962320073ac$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';

const $c3b876b1e2716851$export$b98e411ae80c806f = '/';

// temp solution until a proper versioning
const $8312ee7c6ac197b8$export$93809551debf385f = '0.1.7';

const $dd841321bc924872$export$b98e411ae80c806f = '/';

/* eslint-disable jira/filename-case */ const $07aa4ba62fd6dab4$export$56940a9488e85199 = 'jira.fe.spa-';
const $07aa4ba62fd6dab4$export$45c4b6bf7935c69a = `${$07aa4ba62fd6dab4$export$56940a9488e85199}start`;
const $07aa4ba62fd6dab4$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $07aa4ba62fd6dab4$export$ff834eccc35b9089 = 'appBundleReady';
const $07aa4ba62fd6dab4$export$86b05e34d462ead8 = 'prefetchApiReady';
const $07aa4ba62fd6dab4$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $07aa4ba62fd6dab4$export$3ae43cc1782d058f = 'jswRenderStart';
const $07aa4ba62fd6dab4$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $07aa4ba62fd6dab4$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $07aa4ba62fd6dab4$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $07aa4ba62fd6dab4$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $07aa4ba62fd6dab4$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $07aa4ba62fd6dab4$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $07aa4ba62fd6dab4$export$99c08ec92759c71c = 'tti-raf-mark';
const $07aa4ba62fd6dab4$export$48552baa9db8ce1d = 'tti-raf';

/* eslint-disable jira/filename-case */ const $382ab3343e49976c$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c4e639dc1b853f95$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx


$parcel$global.rlb("5geQX")
//# sourceMappingURL=shared~commons~stable~ar.bf2e4e1f.js.map
